import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type ActivePaymentPlan = {
  __typename?: 'ActivePaymentPlan';
  _id: Scalars['ID']['output'];
  amountPaid: Scalars['Float']['output'];
  nextExpirationDate: Scalars['DateTime']['output'];
  paymentPlan: PaymentPlan;
};

export type AddCustomerInput = {
  address: Scalars['String']['input'];
  avatar?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  devices: Array<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  wallet?: InputMaybe<Scalars['String']['input']>;
};

export type AddDeviceBrandInput = {
  brandLogo: Scalars['String']['input'];
  brandName: Scalars['String']['input'];
  contactDetails: ContactDetailsInput;
  country: Scalars['String']['input'];
};

export type AddDeviceInput = {
  count: Scalars['Float']['input'];
  deviceModel: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  paymentPlan: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
  startingCode: Scalars['String']['input'];
  totalCost: Scalars['Float']['input'];
};

export type AddDeviceModelInput = {
  batteryCapacity: Scalars['String']['input'];
  brand: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  deviceType: Scalars['String']['input'];
  modelName: Scalars['String']['input'];
  powerOutput: Scalars['String']['input'];
  price: Scalars['Float']['input'];
};

export type AlertType = {
  __typename?: 'AlertType';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CartProductInput = {
  count: Scalars['Float']['input'];
  error?: InputMaybe<Array<Scalars['String']['input']>>;
  finalPrice: Scalars['Float']['input'];
  isDiscountOn: Scalars['Boolean']['input'];
  payType: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  productName: Scalars['String']['input'];
  unitPrice: Scalars['Float']['input'];
};

export type CheckoutSummaryInput = {
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  address: Scalars['String']['input'];
  cartItems: Array<CartProductInput>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  email: Scalars['String']['input'];
  exchangeRate?: InputMaybe<Scalars['Float']['input']>;
  fullName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  totalAmount: Scalars['Float']['input'];
  totalDiscount: Scalars['Float']['input'];
  totalFinalPrice: Scalars['Float']['input'];
  totalFinalPriceWithDiscount: Scalars['Float']['input'];
  totalFinalPriceWithDiscountAndTax: Scalars['Float']['input'];
  totalShipping: Scalars['Float']['input'];
  totalTax: Scalars['Float']['input'];
};

export type ContactDetails = {
  __typename?: 'ContactDetails';
  address: Scalars['String']['output'];
  email: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  website: Scalars['String']['output'];
};

export type ContactDetailsInput = {
  address: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  website: Scalars['String']['input'];
};

export type CreateAccountPlanInput = {
  activationCreditLimit: Scalars['String']['input'];
  billingCycle: Scalars['String']['input'];
  currency: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  deviceLimit: Scalars['String']['input'];
  features: Array<Scalars['String']['input']>;
  isPopular: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  transactionFeeRate: Scalars['Float']['input'];
};

export type CreateActivationCreditInput = {
  deviceModel: Scalars['String']['input'];
  noOfActivationDays: Scalars['Float']['input'];
};

export type CreateAdminInput = {
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type CreateCurrencyInput = {
  code: Scalars['String']['input'];
  country: Scalars['String']['input'];
  flag: Scalars['String']['input'];
  name: Scalars['String']['input'];
  rate: Scalars['Float']['input'];
  symbol: Scalars['String']['input'];
};

export type CreateDonationNetworkInput = {
  circleBlockchain: Scalars['String']['input'];
  depositWalletAddress: Scalars['String']['input'];
  depositWalletId: Scalars['String']['input'];
  env: Scalars['String']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  minDonation?: InputMaybe<Scalars['Float']['input']>;
  usdcSymbol: Scalars['String']['input'];
  usdcTokenAddress: Scalars['String']['input'];
  usdcTokenId: Scalars['String']['input'];
  walletType: Scalars['String']['input'];
};

export type CreateFiatAccountInput = {
  accName: Scalars['String']['input'];
  accNumber: Scalars['String']['input'];
  bank: Scalars['String']['input'];
  bankCode: Scalars['String']['input'];
  country: Scalars['String']['input'];
  currencyId: Scalars['String']['input'];
};

export type CreatePaymentBonusFieldInput = {
  fieldId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CreatePaymentBonusInput = {
  bonusCode: Scalars['Float']['input'];
  bonusType: Scalars['String']['input'];
  logicData: Scalars['JSON']['input'];
};

export type CreatePaymentBonusTemplateInput = {
  bonusCode: Scalars['Float']['input'];
  bonusType: Scalars['String']['input'];
  description: Scalars['String']['input'];
  fields: Array<Scalars['String']['input']>;
};

export type CreatePaymentPlanInput = {
  fullPaymentAmount: Scalars['Float']['input'];
  paymentBonuses: Array<CreatePaymentBonusInput>;
  paymentInstalments: Array<PaymentInstalmentInput>;
  planName: Scalars['String']['input'];
};

export type CreateProductInput = {
  averageRating?: InputMaybe<Scalars['Float']['input']>;
  brand: Scalars['String']['input'];
  category: Scalars['String']['input'];
  content: ProductContentInput;
  customFields?: InputMaybe<ProductCustomFieldsInput>;
  delivery?: InputMaybe<ProductDeliveryInput>;
  deviceModel: Scalars['String']['input'];
  discounts?: InputMaybe<Array<ProductDiscountInput>>;
  images?: InputMaybe<Array<ProductImageInput>>;
  inventory: ProductInventoryInput;
  metadata: ProductMetadataInput;
  paymentPlan: Scalars['String']['input'];
  pricing: ProductPricingInput;
  productType: Scalars['String']['input'];
  reviews?: InputMaybe<Array<ProductReviewInput>>;
  seo?: InputMaybe<ProductSeoInput>;
  shippingOrigin: Scalars['String']['input'];
  sku: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  soldCount?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<Scalars['String']['input']>>;
  totalRevenue?: InputMaybe<Scalars['Float']['input']>;
  totalReviews?: InputMaybe<Scalars['Float']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUsdcAccountInput = {
  chain: Scalars['String']['input'];
  publicKey: Scalars['String']['input'];
};

export type Customer = {
  __typename?: 'Customer';
  _id: Scalars['ID']['output'];
  address: Scalars['String']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customerId: Scalars['String']['output'];
  devices: Array<Device>;
  distributor: Distributor;
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  referralCode: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  wallet: Scalars['String']['output'];
};

export type DefaultResponse = {
  __typename?: 'DefaultResponse';
  alert: AlertType;
  pagination?: Maybe<PaginationType>;
  payload?: Maybe<Scalars['JSON']['output']>;
};

export type Device = {
  __typename?: 'Device';
  _id: Scalars['ID']['output'];
  activePaymentPlan?: Maybe<ActivePaymentPlan>;
  amountPaid: Scalars['Float']['output'];
  count: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<Customer>;
  deviceModel: DeviceModel;
  isActive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  lastActivationDate?: Maybe<Scalars['DateTime']['output']>;
  lastLoyaltyRewardDate?: Maybe<Scalars['DateTime']['output']>;
  lastUsageRewardDate?: Maybe<Scalars['DateTime']['output']>;
  nextExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  owner: Distributor;
  paygMode: Scalars['String']['output'];
  paymentPlan: PaymentPlan;
  serialNumber: Scalars['String']['output'];
  startingCode: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalCost: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DeviceBrand = {
  __typename?: 'DeviceBrand';
  _id: Scalars['ID']['output'];
  brandId: Scalars['String']['output'];
  brandLogo: Scalars['String']['output'];
  brandName: Scalars['String']['output'];
  contactDetails: ContactDetails;
  country: Scalars['String']['output'];
};

export type DeviceModel = {
  __typename?: 'DeviceModel';
  _id: Scalars['ID']['output'];
  batteryCapacity: Scalars['String']['output'];
  brand: DeviceBrand;
  description: Scalars['String']['output'];
  deviceType: Scalars['String']['output'];
  modelName: Scalars['String']['output'];
  powerOutput: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export type Distributor = {
  __typename?: 'Distributor';
  _id: Scalars['ID']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EditDeviceBrandInput = {
  brandLogo?: InputMaybe<Scalars['String']['input']>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  contactDetails?: InputMaybe<ContactDetailsInput>;
  country?: InputMaybe<Scalars['String']['input']>;
};

export type EditDeviceInput = {
  count?: InputMaybe<Scalars['Float']['input']>;
  deviceModel?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  paymentPlan?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  startingCode?: InputMaybe<Scalars['String']['input']>;
  totalCost?: InputMaybe<Scalars['Float']['input']>;
};

export type EditDeviceModelInput = {
  batteryCapacity?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
  modelName?: InputMaybe<Scalars['String']['input']>;
  powerOutput?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InitiatePaystackPaymentInput = {
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type MetricsQueryInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addCustomer: DefaultResponse;
  addDevice: DefaultResponse;
  addDeviceBrand: DefaultResponse;
  addDeviceModel: DefaultResponse;
  addDevices: DefaultResponse;
  adminAddDevices: DefaultResponse;
  adminCreateCustomer: DefaultResponse;
  adminCreateDonationNetwork: DefaultResponse;
  adminCreatePaymentPlan: DefaultResponse;
  adminDeleteCustomer: DefaultResponse;
  adminDeleteDonationNetwork: DefaultResponse;
  adminDeletePaymentPlan: DefaultResponse;
  adminDeleteTransaction: DefaultResponse;
  adminSendEmailToCustomerAboutOrder: DefaultResponse;
  adminUpdateCustomer: DefaultResponse;
  adminUpdateDonationNetwork: DefaultResponse;
  adminUpdateOrderStatus: DefaultResponse;
  adminUpdatePaymentPlan: DefaultResponse;
  approveDistributorRegistration: DefaultResponse;
  bulkUpdateOrderStatus: DefaultResponse;
  changeAdminPassword: DefaultResponse;
  changeDistributorAccountPlan: DefaultResponse;
  createAccountPlan: DefaultResponse;
  createActivationCredit: DefaultResponse;
  createAdmin: DefaultResponse;
  createCurrency: DefaultResponse;
  createFiatAccount: DefaultResponse;
  createPaymentBonus: DefaultResponse;
  createPaymentBonusField: DefaultResponse;
  createPaymentBonusTemplate: DefaultResponse;
  createPaymentPlan: DefaultResponse;
  createProduct: DefaultResponse;
  createUsdcAccount: DefaultResponse;
  deleteAccountPlan: DefaultResponse;
  deleteActivationCredit: DefaultResponse;
  deleteCurrency: DefaultResponse;
  deleteCustomer: DefaultResponse;
  deleteCustomers: DefaultResponse;
  deleteDevice: DefaultResponse;
  deleteDeviceBrand: DefaultResponse;
  deleteDeviceModel: DefaultResponse;
  deleteDevices: DefaultResponse;
  deleteDistributor: DefaultResponse;
  deleteFiatAccount: DefaultResponse;
  deletePaymentBonusTemplate: DefaultResponse;
  deletePaymentPlan: DefaultResponse;
  deletePaymentPlans: DefaultResponse;
  deleteProduct: DefaultResponse;
  deleteUsdcAccount: DefaultResponse;
  distributorRegistration: DefaultResponse;
  editDevice: DefaultResponse;
  editDeviceBrand: DefaultResponse;
  editDeviceModel: DefaultResponse;
  editPaymentBonusTemplate: DefaultResponse;
  forgotPassword: DefaultResponse;
  initiateDeposit: DefaultResponse;
  initiatePaystackPayment: DefaultResponse;
  initiateWithdrawalRequest: DefaultResponse;
  linkDeviceToCustomer: DefaultResponse;
  loginAdmin: DefaultResponse;
  rejectDistributorRegistration: DefaultResponse;
  removePaymentBonusField: DefaultResponse;
  reportDeposit: DefaultResponse;
  reportTransaction: DefaultResponse;
  reportWithdrawal: DefaultResponse;
  requestQRCodeDonationInfo: DefaultResponse;
  resendOtp: DefaultResponse;
  resetPassword: DefaultResponse;
  sendContactMessage: DefaultResponse;
  sendPasswordChangeOtp: DefaultResponse;
  setActiveFiatAccount: DefaultResponse;
  setActiveUsdcAccount: DefaultResponse;
  signIn: DefaultResponse;
  unlinkDeviceToCustomer: DefaultResponse;
  updateAccountCurrency: DefaultResponse;
  updateAccountPlan: DefaultResponse;
  updateAdminProfile: DefaultResponse;
  updateCurrency: DefaultResponse;
  updateCustomer: DefaultResponse;
  updateDistributor: DefaultResponse;
  updateDistributorPassword: DefaultResponse;
  updateEmail: DefaultResponse;
  updateEmailRequest: DefaultResponse;
  updateOrder: DefaultResponse;
  updatePaymentPlan: DefaultResponse;
  updateProduct: DefaultResponse;
  updateProductStock: DefaultResponse;
  verifyDeposit: DefaultResponse;
  verifyOtp: DefaultResponse;
  verifyPaystackPayment: DefaultResponse;
  verifyUSDCPayment: DefaultResponse;
};


export type MutationAddCustomerArgs = {
  addCustomerInput: AddCustomerInput;
};


export type MutationAddDeviceArgs = {
  addDeviceInput: AddDeviceInput;
};


export type MutationAddDeviceBrandArgs = {
  addDeviceBrandInput: AddDeviceBrandInput;
};


export type MutationAddDeviceModelArgs = {
  addDeviceModelInput: AddDeviceModelInput;
};


export type MutationAddDevicesArgs = {
  addDevicesInput: Array<AddDeviceInput>;
};


export type MutationAdminAddDevicesArgs = {
  addDevicesInput: Array<AddDeviceInput>;
};


export type MutationAdminCreateCustomerArgs = {
  createCustomerInput: AddCustomerInput;
};


export type MutationAdminCreateDonationNetworkArgs = {
  input: CreateDonationNetworkInput;
};


export type MutationAdminCreatePaymentPlanArgs = {
  createPaymentPlanInput: CreatePaymentPlanInput;
};


export type MutationAdminDeleteCustomerArgs = {
  customerId: Scalars['String']['input'];
};


export type MutationAdminDeleteDonationNetworkArgs = {
  id: Scalars['String']['input'];
};


export type MutationAdminDeletePaymentPlanArgs = {
  paymentPlanId: Scalars['String']['input'];
};


export type MutationAdminDeleteTransactionArgs = {
  transactionId: Scalars['String']['input'];
};


export type MutationAdminSendEmailToCustomerAboutOrderArgs = {
  emailInput: SendEmailInput;
  orderId: Scalars['String']['input'];
};


export type MutationAdminUpdateCustomerArgs = {
  customerId: Scalars['String']['input'];
  updateCustomerInput: UpdateCustomerInput;
};


export type MutationAdminUpdateDonationNetworkArgs = {
  input: UpdateDonationNetworkInput;
};


export type MutationAdminUpdateOrderStatusArgs = {
  orderId: Scalars['String']['input'];
  status: Scalars['String']['input'];
};


export type MutationAdminUpdatePaymentPlanArgs = {
  paymentPlanId: Scalars['String']['input'];
  updatePaymentPlanInput: UpdatePaymentPlanInput;
};


export type MutationApproveDistributorRegistrationArgs = {
  registrationId: Scalars['String']['input'];
};


export type MutationBulkUpdateOrderStatusArgs = {
  orderIds: Array<Scalars['String']['input']>;
  status: Scalars['String']['input'];
};


export type MutationChangeAdminPasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  otpCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationChangeDistributorAccountPlanArgs = {
  accountPlanId: Scalars['String']['input'];
};


export type MutationCreateAccountPlanArgs = {
  createAccountPlanInput: CreateAccountPlanInput;
};


export type MutationCreateActivationCreditArgs = {
  createActivationCreditInput: CreateActivationCreditInput;
};


export type MutationCreateAdminArgs = {
  createAdminInput: CreateAdminInput;
};


export type MutationCreateCurrencyArgs = {
  createCurrencyInput: CreateCurrencyInput;
};


export type MutationCreateFiatAccountArgs = {
  createFiatAccountInput: CreateFiatAccountInput;
};


export type MutationCreatePaymentBonusArgs = {
  createPaymentBonusInput: CreatePaymentBonusInput;
};


export type MutationCreatePaymentBonusFieldArgs = {
  createPaymentBonusFieldInput: CreatePaymentBonusFieldInput;
};


export type MutationCreatePaymentBonusTemplateArgs = {
  createPaymentBonusTemplateInput: CreatePaymentBonusTemplateInput;
};


export type MutationCreatePaymentPlanArgs = {
  createPaymentPlanInput: CreatePaymentPlanInput;
};


export type MutationCreateProductArgs = {
  createProductInput: CreateProductInput;
};


export type MutationCreateUsdcAccountArgs = {
  createUsdcAccountInput: CreateUsdcAccountInput;
};


export type MutationDeleteAccountPlanArgs = {
  accountPlanId: Scalars['String']['input'];
};


export type MutationDeleteActivationCreditArgs = {
  activationCreditId: Scalars['String']['input'];
};


export type MutationDeleteCurrencyArgs = {
  currencyId: Scalars['String']['input'];
};


export type MutationDeleteCustomerArgs = {
  customerId: Scalars['String']['input'];
};


export type MutationDeleteCustomersArgs = {
  customerIds: Array<Scalars['String']['input']>;
};


export type MutationDeleteDeviceArgs = {
  deviceId: Scalars['String']['input'];
};


export type MutationDeleteDeviceBrandArgs = {
  deviceBrandId: Scalars['String']['input'];
};


export type MutationDeleteDeviceModelArgs = {
  deviceModelId: Scalars['String']['input'];
};


export type MutationDeleteDevicesArgs = {
  deviceIds: Array<Scalars['String']['input']>;
};


export type MutationDeleteFiatAccountArgs = {
  fiatAccountId: Scalars['String']['input'];
};


export type MutationDeletePaymentBonusTemplateArgs = {
  paymentBonusTemplateId: Scalars['String']['input'];
};


export type MutationDeletePaymentPlanArgs = {
  paymentPlanId: Scalars['String']['input'];
};


export type MutationDeletePaymentPlansArgs = {
  paymentPlanIds: Array<Scalars['String']['input']>;
};


export type MutationDeleteProductArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteUsdcAccountArgs = {
  usdcAccountId: Scalars['String']['input'];
};


export type MutationDistributorRegistrationArgs = {
  registrationInput: RegistrationInput;
};


export type MutationEditDeviceArgs = {
  deviceId: Scalars['String']['input'];
  editDeviceInput: EditDeviceInput;
};


export type MutationEditDeviceBrandArgs = {
  deviceBrandId: Scalars['String']['input'];
  editDeviceBrandInput: EditDeviceBrandInput;
};


export type MutationEditDeviceModelArgs = {
  deviceModelId: Scalars['String']['input'];
  editDeviceModelInput: EditDeviceModelInput;
};


export type MutationEditPaymentBonusTemplateArgs = {
  editPaymentBonusTemplateInput: UpdatePaymentBonusTemplateInput;
  paymentBonusTemplateId: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationInitiateDepositArgs = {
  depositAmount: Scalars['Float']['input'];
};


export type MutationInitiatePaystackPaymentArgs = {
  initiatePaystackPaymentInput: InitiatePaystackPaymentInput;
};


export type MutationInitiateWithdrawalRequestArgs = {
  withdrawalRequestInput: WithdrawalRequestInput;
};


export type MutationLinkDeviceToCustomerArgs = {
  customerId: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
};


export type MutationLoginAdminArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationRejectDistributorRegistrationArgs = {
  reason: Scalars['String']['input'];
  registrationId: Scalars['String']['input'];
};


export type MutationRemovePaymentBonusFieldArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReportDepositArgs = {
  depositId: Scalars['String']['input'];
  message: Scalars['String']['input'];
};


export type MutationReportTransactionArgs = {
  message: Scalars['String']['input'];
  transactionId: Scalars['String']['input'];
};


export type MutationReportWithdrawalArgs = {
  message: Scalars['String']['input'];
  withdrawalId: Scalars['String']['input'];
};


export type MutationRequestQrCodeDonationInfoArgs = {
  blockchain: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
  walletType: Scalars['String']['input'];
};


export type MutationResendOtpArgs = {
  email: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String']['input'];
};


export type MutationSendContactMessageArgs = {
  sendEmailInput: SendEmailInput;
};


export type MutationSetActiveFiatAccountArgs = {
  fiatAccountId: Scalars['String']['input'];
};


export type MutationSetActiveUsdcAccountArgs = {
  usdcAccountId: Scalars['String']['input'];
};


export type MutationSignInArgs = {
  signInInput: SignInInput;
};


export type MutationUnlinkDeviceToCustomerArgs = {
  customerId: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
};


export type MutationUpdateAccountCurrencyArgs = {
  currencyId: Scalars['String']['input'];
};


export type MutationUpdateAccountPlanArgs = {
  accountPlanId: Scalars['String']['input'];
  updateAccountPlanInput: UpdateAccountPlanInput;
};


export type MutationUpdateAdminProfileArgs = {
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
};


export type MutationUpdateCurrencyArgs = {
  currencyId: Scalars['String']['input'];
  updateCurrencyInput: UpdateCurrencyInput;
};


export type MutationUpdateCustomerArgs = {
  customerId: Scalars['String']['input'];
  updateCustomerInput: UpdateCustomerInput;
};


export type MutationUpdateDistributorArgs = {
  id: Scalars['String']['input'];
  input: UpdateDistributorInput;
};


export type MutationUpdateDistributorPasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationUpdateEmailArgs = {
  newEmail: Scalars['String']['input'];
};


export type MutationUpdateOrderArgs = {
  orderId: Scalars['String']['input'];
  updateOrderInput: UpdateOrderInput;
};


export type MutationUpdatePaymentPlanArgs = {
  paymentPlanId: Scalars['String']['input'];
  updatePaymentPlanInput: UpdatePaymentPlanInput;
};


export type MutationUpdateProductArgs = {
  id: Scalars['String']['input'];
  updateProductInput: UpdateProductInput;
};


export type MutationUpdateProductStockArgs = {
  id: Scalars['String']['input'];
  stockCount: Scalars['Int']['input'];
};


export type MutationVerifyDepositArgs = {
  currenyId: Scalars['String']['input'];
  reference: Scalars['String']['input'];
};


export type MutationVerifyOtpArgs = {
  email: Scalars['String']['input'];
  otpCode: Scalars['String']['input'];
};


export type MutationVerifyPaystackPaymentArgs = {
  checkoutSummary: CheckoutSummaryInput;
  reference: Scalars['String']['input'];
};


export type MutationVerifyUsdcPaymentArgs = {
  checkoutSummary: CheckoutSummaryInput;
  transactionMemo: Scalars['String']['input'];
};

export type OrderItemDto = {
  productId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  totalPrice: Scalars['Float']['input'];
  unitPrice: Scalars['Float']['input'];
};

export type PaginationInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type PaginationType = {
  __typename?: 'PaginationType';
  currentPage: Scalars['Float']['output'];
  pageItems: Scalars['Float']['output'];
  totalFilteredItems: Scalars['Float']['output'];
  totalItems: Scalars['Float']['output'];
  totalPages: Scalars['Float']['output'];
};

export type PaymentInstalment = {
  __typename?: 'PaymentInstalment';
  activationAmount: Scalars['Float']['output'];
  activationDays: Scalars['Float']['output'];
};

export type PaymentInstalmentInput = {
  activationAmount: Scalars['Float']['input'];
  activationDays: Scalars['Float']['input'];
};

export type PaymentPlan = {
  __typename?: 'PaymentPlan';
  _id: Scalars['ID']['output'];
  devices: Scalars['Float']['output'];
  distributor: Scalars['ID']['output'];
  fullPaymentAmount: Scalars['Float']['output'];
  paymentInstalments: Array<PaymentInstalment>;
  planName: Scalars['String']['output'];
};

export type ProductContentInput = {
  description: Scalars['String']['input'];
  shortDescription?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCustomFieldsInput = {
  expiry?: InputMaybe<Scalars['Boolean']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  manufacturedDate?: InputMaybe<Scalars['DateTime']['input']>;
  manufacturer?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturerName?: InputMaybe<Scalars['String']['input']>;
  warranties?: InputMaybe<Scalars['Boolean']['input']>;
  warranty?: InputMaybe<Scalars['String']['input']>;
};

export type ProductDeliveryInput = {
  charge?: InputMaybe<Scalars['Float']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
};

export type ProductDiscountInput = {
  deadline: Scalars['DateTime']['input'];
  discountAmount: Scalars['Float']['input'];
  discountOn: Scalars['String']['input'];
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductImageInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  url: Scalars['String']['input'];
};

export type ProductInventoryInput = {
  location?: InputMaybe<Scalars['String']['input']>;
  quantityAlert: Scalars['Float']['input'];
  status?: Scalars['String']['input'];
  stockCount: Scalars['Float']['input'];
};

export type ProductMetadataInput = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type ProductPricingInput = {
  costPrice: Scalars['Float']['input'];
  discountType?: InputMaybe<Scalars['String']['input']>;
  discountValue?: InputMaybe<Scalars['Float']['input']>;
  fullPayment: Scalars['Float']['input'];
  leaseFee: Scalars['Float']['input'];
  tax?: InputMaybe<Scalars['Float']['input']>;
  taxType?: InputMaybe<Scalars['String']['input']>;
};

export type ProductQueryInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ProductReviewInput = {
  comment: Scalars['String']['input'];
  customerEmail: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
  helpfulCount?: InputMaybe<Scalars['Float']['input']>;
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Float']['input'];
  title: Scalars['String']['input'];
};

export type ProductSeoInput = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  adminFetchActivationDebugTrace: DefaultResponse;
  adminFetchActivationDebugTraces: DefaultResponse;
  adminFetchAvailableDevices: DefaultResponse;
  adminFetchCustomerCount: DefaultResponse;
  adminFetchCustomers: DefaultResponse;
  adminFetchDeviceBrands: DefaultResponse;
  adminFetchDeviceCount: DefaultResponse;
  adminFetchDeviceModels: DefaultResponse;
  adminFetchDevices: DefaultResponse;
  adminFetchDistributorCount: DefaultResponse;
  adminFetchDonationNetworks: DefaultResponse;
  adminFetchOrder: DefaultResponse;
  adminFetchOrders: DefaultResponse;
  adminFetchPaymentPlans: DefaultResponse;
  adminFetchProcessedCircleWebhook: DefaultResponse;
  adminFetchProcessedCircleWebhookByTxHash: DefaultResponse;
  adminFetchProcessedCircleWebhooks: DefaultResponse;
  adminFetchPurchasedDevicesCount: DefaultResponse;
  adminFetchTotalRevenue: DefaultResponse;
  adminFetchTransaction: DefaultResponse;
  adminFetchTransactionCount: DefaultResponse;
  adminFetchTransactions: DefaultResponse;
  adminFetchUsdcTransactionsSum: DefaultResponse;
  adminFetchUssdTransactionsSum: DefaultResponse;
  adminGetDashboardMetrics: DefaultResponse;
  exportOrdersToCSV: DefaultResponse;
  fetchAccRevenues: DefaultResponse;
  fetchAccountPlanActions: DefaultResponse;
  fetchAccountPlans: DefaultResponse;
  fetchActivationCredits: DefaultResponse;
  fetchActivePaymentPlan: DefaultResponse;
  fetchAdminPaymentPlansOnly: DefaultResponse;
  fetchAllCurrencies: DefaultResponse;
  fetchAllDistributors: DefaultResponse;
  fetchAllFiatCurrencies: DefaultResponse;
  fetchAllProducts: DefaultResponse;
  fetchAvailableBalances: DefaultResponse;
  fetchBills: DefaultResponse;
  fetchCustomer: DefaultResponse;
  fetchCustomerCount: DefaultResponse;
  fetchCustomerDevices: DefaultResponse;
  fetchCustomerStats: DefaultResponse;
  fetchCustomerTransactions: DefaultResponse;
  fetchCustomers: DefaultResponse;
  fetchDeposit: DefaultResponse;
  fetchDepositsAndWithdrawals: DefaultResponse;
  fetchDevice: DefaultResponse;
  fetchDeviceBrands: DefaultResponse;
  fetchDeviceCount: DefaultResponse;
  fetchDeviceModels: DefaultResponse;
  fetchDevices: DefaultResponse;
  fetchDistributorAndRegistration: DefaultResponse;
  fetchDistributorCountries: DefaultResponse;
  fetchDistributorDepositCurrencies: DefaultResponse;
  fetchDistributorRegistrationById: DefaultResponse;
  fetchDistributorRegistrations: DefaultResponse;
  fetchDonationNetworksPublic: DefaultResponse;
  fetchExpiredDevices: DefaultResponse;
  fetchFiatAccounts: DefaultResponse;
  fetchGraphData: DefaultResponse;
  fetchModelsByBrand: DefaultResponse;
  fetchMonthlyCreditUsage: DefaultResponse;
  fetchPaymentBonusFields: DefaultResponse;
  fetchPaymentBonusTemplates: DefaultResponse;
  fetchPaymentPlan: DefaultResponse;
  fetchPaymentPlans: DefaultResponse;
  fetchProductById: DefaultResponse;
  fetchRevenueOverviewData: DefaultResponse;
  fetchSoldOutDevicesCount: DefaultResponse;
  fetchSupportedCurrencies: DefaultResponse;
  fetchTotalDeviceCount: DefaultResponse;
  fetchTransaction: DefaultResponse;
  fetchTransactionCount: DefaultResponse;
  fetchTransactionStatByTimeline: DefaultResponse;
  fetchTransactions: DefaultResponse;
  fetchUsdcAccounts: DefaultResponse;
  fetchWithdrawal: DefaultResponse;
  fetchWithdrawals: DefaultResponse;
  findAllProducts: DefaultResponse;
  findOrderByOrderNumber: DefaultResponse;
  findProductById: DefaultResponse;
  findProductBySlug: DefaultResponse;
  generateInvoice: DefaultResponse;
  getCurrentAdminProfile: DefaultResponse;
  getDistributorData: DefaultResponse;
  getFeaturedProducts: DefaultResponse;
  getInventoryAlerts: DefaultResponse;
  getInventoryValue: DefaultResponse;
  getLowStockProducts: DefaultResponse;
  getMetricsTimeSeries: DefaultResponse;
  getOutOfStockProducts: DefaultResponse;
  getProductMetrics: DefaultResponse;
  getProductPerformance: DefaultResponse;
  getProductsByCategory: DefaultResponse;
  getRevenueForecast: DefaultResponse;
  searchProducts: DefaultResponse;
};


export type QueryAdminFetchActivationDebugTraceArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdminFetchActivationDebugTracesArgs = {
  params: QueryParamsInput;
};


export type QueryAdminFetchAvailableDevicesArgs = {
  params: QueryParamsInput;
};


export type QueryAdminFetchCustomersArgs = {
  params: QueryParamsInput;
};


export type QueryAdminFetchDeviceBrandsArgs = {
  params: QueryParamsInput;
};


export type QueryAdminFetchDeviceModelsArgs = {
  params: QueryParamsInput;
};


export type QueryAdminFetchDevicesArgs = {
  params: QueryParamsInput;
};


export type QueryAdminFetchDonationNetworksArgs = {
  params: QueryParamsInput;
};


export type QueryAdminFetchOrderArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryAdminFetchOrdersArgs = {
  params: QueryParamsInput;
};


export type QueryAdminFetchPaymentPlansArgs = {
  params: QueryParamsInput;
};


export type QueryAdminFetchProcessedCircleWebhookArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdminFetchProcessedCircleWebhookByTxHashArgs = {
  blockchain: Scalars['String']['input'];
  txHash: Scalars['String']['input'];
};


export type QueryAdminFetchProcessedCircleWebhooksArgs = {
  params: QueryParamsInput;
};


export type QueryAdminFetchTransactionArgs = {
  transactionId: Scalars['String']['input'];
};


export type QueryAdminFetchTransactionsArgs = {
  params: QueryParamsInput;
};


export type QueryAdminGetDashboardMetricsArgs = {
  queryInput?: InputMaybe<MetricsQueryInput>;
};


export type QueryFetchAccountPlanActionsArgs = {
  accountPlanId: Scalars['String']['input'];
};


export type QueryFetchActivationCreditsArgs = {
  params: QueryParamsInput;
};


export type QueryFetchActivePaymentPlanArgs = {
  activePaymentPlanId: Scalars['String']['input'];
};


export type QueryFetchAdminPaymentPlansOnlyArgs = {
  params: QueryParamsInput;
};


export type QueryFetchAllDistributorsArgs = {
  params: QueryParamsInput;
};


export type QueryFetchCustomerArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryFetchCustomerDevicesArgs = {
  customerId: Scalars['String']['input'];
  params: QueryParamsInput;
};


export type QueryFetchCustomerTransactionsArgs = {
  customerId: Scalars['String']['input'];
  params: QueryParamsInput;
};


export type QueryFetchCustomersArgs = {
  params: QueryParamsInput;
};


export type QueryFetchDepositArgs = {
  depositId: Scalars['String']['input'];
};


export type QueryFetchDepositsAndWithdrawalsArgs = {
  params: QueryParamsInput;
};


export type QueryFetchDeviceArgs = {
  deviceId: Scalars['String']['input'];
};


export type QueryFetchDeviceBrandsArgs = {
  params: QueryParamsInput;
};


export type QueryFetchDeviceModelsArgs = {
  params: QueryParamsInput;
};


export type QueryFetchDevicesArgs = {
  params: QueryParamsInput;
};


export type QueryFetchDistributorAndRegistrationArgs = {
  id: Scalars['String']['input'];
};


export type QueryFetchDistributorRegistrationByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryFetchDistributorRegistrationsArgs = {
  params: QueryParamsInput;
};


export type QueryFetchDonationNetworksPublicArgs = {
  env: Scalars['String']['input'];
};


export type QueryFetchModelsByBrandArgs = {
  brandId: Scalars['String']['input'];
};


export type QueryFetchPaymentBonusTemplatesArgs = {
  params: QueryParamsInput;
};


export type QueryFetchPaymentPlanArgs = {
  paymentPlanId: Scalars['String']['input'];
};


export type QueryFetchPaymentPlansArgs = {
  params: QueryParamsInput;
};


export type QueryFetchProductByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryFetchRevenueOverviewDataArgs = {
  timeline: Scalars['String']['input'];
};


export type QueryFetchTransactionArgs = {
  transactionId: Scalars['String']['input'];
};


export type QueryFetchTransactionStatByTimelineArgs = {
  lastXDays: Scalars['Float']['input'];
};


export type QueryFetchTransactionsArgs = {
  params: QueryParamsInput;
};


export type QueryFetchWithdrawalArgs = {
  withdrawalId: Scalars['String']['input'];
};


export type QueryFetchWithdrawalsArgs = {
  params: QueryParamsInput;
};


export type QueryFindAllProductsArgs = {
  queryInput?: InputMaybe<ProductQueryInput>;
};


export type QueryFindOrderByOrderNumberArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryFindProductByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryFindProductBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGenerateInvoiceArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryGetFeaturedProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetMetricsTimeSeriesArgs = {
  queryInput?: InputMaybe<MetricsQueryInput>;
};


export type QueryGetProductMetricsArgs = {
  queryInput?: InputMaybe<MetricsQueryInput>;
};


export type QueryGetProductPerformanceArgs = {
  queryInput?: InputMaybe<MetricsQueryInput>;
};


export type QueryGetProductsByCategoryArgs = {
  category: Scalars['String']['input'];
};


export type QuerySearchProductsArgs = {
  limit?: Scalars['Int']['input'];
  searchTerm: Scalars['String']['input'];
};

export type QueryParamsInput = {
  filter?: InputMaybe<FilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type RegistrationInput = {
  businessDescription: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  countryOfReg?: InputMaybe<Scalars['String']['input']>;
  dob: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  noOfDevices: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  regDoc?: InputMaybe<Scalars['String']['input']>;
  regNo?: InputMaybe<Scalars['String']['input']>;
  staffSize: Scalars['String']['input'];
  state: Scalars['String']['input'];
  status: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
  verificationFile: Scalars['String']['input'];
  verificationOption: Scalars['String']['input'];
};

export type SearchInput = {
  key?: InputMaybe<Scalars['String']['input']>;
};

export type SendEmailInput = {
  body: Scalars['String']['input'];
  distributorId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name?: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type SignInInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type SortInput = {
  field: Scalars['String']['input'];
  order: SortOrder;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type UpdateAccountPlanInput = {
  activationCreditLimit?: InputMaybe<Scalars['String']['input']>;
  billingCycle?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  deviceLimit?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  isPopular?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  transactionFeeRate?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateCurrencyInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  flag?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  devices?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  wallet?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDistributorInput = {
  accountPlan?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  businessDescription?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  paymentId: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDonationNetworkInput = {
  circleBlockchain?: InputMaybe<Scalars['String']['input']>;
  depositWalletAddress?: InputMaybe<Scalars['String']['input']>;
  depositWalletId?: InputMaybe<Scalars['String']['input']>;
  env?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  minDonation?: InputMaybe<Scalars['Float']['input']>;
  usdcSymbol?: InputMaybe<Scalars['String']['input']>;
  usdcTokenAddress?: InputMaybe<Scalars['String']['input']>;
  usdcTokenId?: InputMaybe<Scalars['String']['input']>;
  walletType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderInput = {
  changeReason?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<OrderItemDto>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaymentBonusTemplateInput = {
  bonusCode?: InputMaybe<Scalars['Float']['input']>;
  bonusType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdatePaymentPlanInput = {
  fullPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
  paymentBonuses?: InputMaybe<Array<CreatePaymentBonusInput>>;
  paymentInstalments?: InputMaybe<Array<PaymentInstalmentInput>>;
  planName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductInput = {
  averageRating?: InputMaybe<Scalars['Float']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<ProductContentInput>;
  customFields?: InputMaybe<ProductCustomFieldsInput>;
  delivery?: InputMaybe<ProductDeliveryInput>;
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<ProductDiscountInput>>;
  images?: InputMaybe<Array<ProductImageInput>>;
  inventory?: InputMaybe<ProductInventoryInput>;
  metadata?: InputMaybe<ProductMetadataInput>;
  paymentPlan?: InputMaybe<Scalars['String']['input']>;
  pricing?: InputMaybe<ProductPricingInput>;
  productType?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<Array<ProductReviewInput>>;
  seo?: InputMaybe<ProductSeoInput>;
  shippingOrigin?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  soldCount?: InputMaybe<Scalars['Float']['input']>;
  specifications?: InputMaybe<Array<Scalars['String']['input']>>;
  totalRevenue?: InputMaybe<Scalars['Float']['input']>;
  totalReviews?: InputMaybe<Scalars['Float']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type WithdrawalRequestInput = {
  account: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  type: Scalars['String']['input'];
};

export type CreateAccountPlanMutationVariables = Exact<{
  createAccountPlanInput: CreateAccountPlanInput;
}>;


export type CreateAccountPlanMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type UpdateAccountPlanMutationVariables = Exact<{
  accountPlanId: Scalars['String']['input'];
  updateAccountPlanInput: UpdateAccountPlanInput;
}>;


export type UpdateAccountPlanMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type DeleteAccountPlanMutationVariables = Exact<{
  accountPlanId: Scalars['String']['input'];
}>;


export type DeleteAccountPlanMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type AdminFetchCustomersQueryVariables = Exact<{
  params: QueryParamsInput;
}>;


export type AdminFetchCustomersQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', message: string, type: string }, pagination?: { __typename?: 'PaginationType', currentPage: number, pageItems: number, totalItems: number, totalPages: number, totalFilteredItems: number } | null } };

export type AdminCreateCustomerMutationVariables = Exact<{
  createCustomerInput: AddCustomerInput;
}>;


export type AdminCreateCustomerMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', alert: { __typename?: 'AlertType', message: string, type: string } } };

export type FetchCustomerByIdQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type FetchCustomerByIdQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', message: string, type: string } } };

export type AdminUpdateCustomerMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
  updateCustomerInput: UpdateCustomerInput;
}>;


export type AdminUpdateCustomerMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', alert: { __typename?: 'AlertType', message: string, type: string } } };

export type AdminDeleteCustomerMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type AdminDeleteCustomerMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', alert: { __typename?: 'AlertType', message: string, type: string } } };

export type GetAdminDashboardMetricsQueryVariables = Exact<{
  queryInput?: InputMaybe<MetricsQueryInput>;
}>;


export type GetAdminDashboardMetricsQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type AddDeviceBrandMutationVariables = Exact<{
  addDeviceBrandInput: AddDeviceBrandInput;
}>;


export type AddDeviceBrandMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', alert: { __typename?: 'AlertType', message: string, type: string } } };

export type FetchDeviceBrandsQueryVariables = Exact<{
  params: QueryParamsInput;
}>;


export type FetchDeviceBrandsQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', message: string, type: string }, pagination?: { __typename?: 'PaginationType', currentPage: number, pageItems: number, totalItems: number, totalPages: number, totalFilteredItems: number } | null } };

export type EditDeviceBrandMutationVariables = Exact<{
  deviceBrandId: Scalars['String']['input'];
  editDeviceBrandInput: EditDeviceBrandInput;
}>;


export type EditDeviceBrandMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', alert: { __typename?: 'AlertType', message: string, type: string } } };

export type DeleteDeviceBrandMutationVariables = Exact<{
  deviceBrandId: Scalars['String']['input'];
}>;


export type DeleteDeviceBrandMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', alert: { __typename?: 'AlertType', message: string, type: string } } };

export type AddDeviceModelMutationVariables = Exact<{
  addDeviceModelInput: AddDeviceModelInput;
}>;


export type AddDeviceModelMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', alert: { __typename?: 'AlertType', message: string, type: string } } };

export type FetchDeviceModelsQueryVariables = Exact<{
  params: QueryParamsInput;
}>;


export type FetchDeviceModelsQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', message: string, type: string }, pagination?: { __typename?: 'PaginationType', currentPage: number, pageItems: number, totalItems: number, totalPages: number, totalFilteredItems: number } | null } };

export type EditDeviceModelMutationVariables = Exact<{
  deviceModelId: Scalars['String']['input'];
  editDeviceModelInput: EditDeviceModelInput;
}>;


export type EditDeviceModelMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', alert: { __typename?: 'AlertType', message: string, type: string } } };

export type DeleteDeviceModelMutationVariables = Exact<{
  deviceModelId: Scalars['String']['input'];
}>;


export type DeleteDeviceModelMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', alert: { __typename?: 'AlertType', message: string, type: string } } };

export type AdminFetchDevicesQueryVariables = Exact<{
  params: QueryParamsInput;
}>;


export type AdminFetchDevicesQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string }, pagination?: { __typename?: 'PaginationType', currentPage: number, pageItems: number, totalItems: number, totalPages: number, totalFilteredItems: number } | null } };

export type FetchModelsByBrandQueryVariables = Exact<{
  brandId: Scalars['String']['input'];
}>;


export type FetchModelsByBrandQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', message: string, type: string } } };

export type AddDeviceMutationVariables = Exact<{
  addDeviceInput: AddDeviceInput;
}>;


export type AddDeviceMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', alert: { __typename?: 'AlertType', message: string, type: string } } };

export type EditDeviceMutationVariables = Exact<{
  deviceId: Scalars['String']['input'];
  editDeviceInput: EditDeviceInput;
}>;


export type EditDeviceMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', alert: { __typename?: 'AlertType', message: string, type: string } } };

export type DeleteDevicesMutationVariables = Exact<{
  deviceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteDevicesMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', alert: { __typename?: 'AlertType', message: string, type: string } } };

export type FetchDeviceQueryVariables = Exact<{
  deviceId: Scalars['String']['input'];
}>;


export type FetchDeviceQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type AdminAddDevicesMutationVariables = Exact<{
  addDevicesInput: Array<AddDeviceInput> | AddDeviceInput;
}>;


export type AdminAddDevicesMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', message: string, type: string } } };

export type AdminFetchAvailableDevicesQueryVariables = Exact<{
  params: QueryParamsInput;
}>;


export type AdminFetchAvailableDevicesQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', message: string, type: string } } };

export type FetchDistributorRegistrationsQueryVariables = Exact<{
  params: QueryParamsInput;
}>;


export type FetchDistributorRegistrationsQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', message: string, type: string }, pagination?: { __typename?: 'PaginationType', currentPage: number, pageItems: number, totalItems: number, totalPages: number, totalFilteredItems: number } | null } };

export type FetchDistributorRegistrationByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FetchDistributorRegistrationByIdQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', message: string, type: string } } };

export type ApproveDistributorRegistrationMutationVariables = Exact<{
  registrationId: Scalars['String']['input'];
}>;


export type ApproveDistributorRegistrationMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', message: string, type: string } } };

export type RejectDistributorRegistrationMutationVariables = Exact<{
  registrationId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;


export type RejectDistributorRegistrationMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', message: string, type: string } } };

export type FetchAllDistributorsQueryVariables = Exact<{
  params: QueryParamsInput;
}>;


export type FetchAllDistributorsQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string }, pagination?: { __typename?: 'PaginationType', currentPage: number, pageItems: number, totalItems: number, totalPages: number, totalFilteredItems: number } | null } };

export type FetchDistributorCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchDistributorCountriesQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type FetchDistributorAndRegistrationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FetchDistributorAndRegistrationQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type UpdateDistributorMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateDistributorInput;
}>;


export type UpdateDistributorMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type AdminFetchDonationNetworksQueryVariables = Exact<{
  params: QueryParamsInput;
}>;


export type AdminFetchDonationNetworksQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string }, pagination?: { __typename?: 'PaginationType', totalItems: number, totalFilteredItems: number, totalPages: number, currentPage: number, pageItems: number } | null } };

export type AdminCreateDonationNetworkMutationVariables = Exact<{
  input: CreateDonationNetworkInput;
}>;


export type AdminCreateDonationNetworkMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type AdminUpdateDonationNetworkMutationVariables = Exact<{
  input: UpdateDonationNetworkInput;
}>;


export type AdminUpdateDonationNetworkMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type AdminDeleteDonationNetworkMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminDeleteDonationNetworkMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', alert: { __typename?: 'AlertType', type: string, message: string } } };

export type GetInventoryValueQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInventoryValueQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type GetInventoryAlertsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInventoryAlertsQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type GetProductMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductMetricsQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type GetMetricsTimeSeriesQueryVariables = Exact<{
  queryInput?: InputMaybe<MetricsQueryInput>;
}>;


export type GetMetricsTimeSeriesQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type GetProductPerformanceQueryVariables = Exact<{
  queryInput?: InputMaybe<MetricsQueryInput>;
}>;


export type GetProductPerformanceQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type GetRevenueForecastQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRevenueForecastQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type LoginAdminMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginAdminMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', message: string, type: string } } };

export type AdminFetchOrdersQueryVariables = Exact<{
  params: QueryParamsInput;
}>;


export type AdminFetchOrdersQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', message: string, type: string }, pagination?: { __typename?: 'PaginationType', currentPage: number, pageItems: number, totalItems: number, totalPages: number, totalFilteredItems: number } | null } };

export type AdminFetchOrderQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type AdminFetchOrderQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', message: string, type: string } } };

export type AdminUpdateOrderStatusMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  status: Scalars['String']['input'];
}>;


export type AdminUpdateOrderStatusMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', message: string, type: string } } };

export type AdminSendEmailToCustomerAboutOrderMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  emailInput: SendEmailInput;
}>;


export type AdminSendEmailToCustomerAboutOrderMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', message: string, type: string } } };

export type UpdateOrderMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  updateOrderInput: UpdateOrderInput;
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type AdminFetchPaymentPlansQueryVariables = Exact<{
  params: QueryParamsInput;
}>;


export type AdminFetchPaymentPlansQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string }, pagination?: { __typename?: 'PaginationType', currentPage: number, pageItems: number, totalItems: number, totalPages: number, totalFilteredItems: number } | null } };

export type FetchAdminPaymentPlansOnlyQueryVariables = Exact<{
  params: QueryParamsInput;
}>;


export type FetchAdminPaymentPlansOnlyQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string }, pagination?: { __typename?: 'PaginationType', currentPage: number, pageItems: number, totalItems: number, totalPages: number, totalFilteredItems: number } | null } };

export type FetchPaymentBonusFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchPaymentBonusFieldsQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type FetchPaymentBonusTemplatesQueryVariables = Exact<{
  params: QueryParamsInput;
}>;


export type FetchPaymentBonusTemplatesQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', message: string, type: string }, pagination?: { __typename?: 'PaginationType', currentPage: number, pageItems: number, totalItems: number, totalPages: number, totalFilteredItems: number } | null } };

export type CreatePaymentBonusTemplateMutationVariables = Exact<{
  createPaymentBonusTemplateInput: CreatePaymentBonusTemplateInput;
}>;


export type CreatePaymentBonusTemplateMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type CreatePaymentBonusFieldMutationVariables = Exact<{
  createPaymentBonusFieldInput: CreatePaymentBonusFieldInput;
}>;


export type CreatePaymentBonusFieldMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type DeletePaymentBonusFieldMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePaymentBonusFieldMutation = { __typename?: 'Mutation', removePaymentBonusField: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type DeletePaymentBonusTemplateMutationVariables = Exact<{
  paymentBonusTemplateId: Scalars['String']['input'];
}>;


export type DeletePaymentBonusTemplateMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type EditPaymentBonusTemplateMutationVariables = Exact<{
  paymentBonusTemplateId: Scalars['String']['input'];
  editPaymentBonusTemplateInput: UpdatePaymentBonusTemplateInput;
}>;


export type EditPaymentBonusTemplateMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type CreatePaymentPlanMutationVariables = Exact<{
  createPaymentPlanInput: CreatePaymentPlanInput;
}>;


export type CreatePaymentPlanMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type UpdatePaymentPlanMutationVariables = Exact<{
  updatePaymentPlanInput: UpdatePaymentPlanInput;
  paymentPlanId: Scalars['String']['input'];
}>;


export type UpdatePaymentPlanMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type DeletePaymentPlanMutationVariables = Exact<{
  paymentPlanId: Scalars['String']['input'];
}>;


export type DeletePaymentPlanMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type CreateProductMutationVariables = Exact<{
  createProductInput: CreateProductInput;
}>;


export type CreateProductMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type FetchProductsQueryVariables = Exact<{
  queryInput?: InputMaybe<ProductQueryInput>;
}>;


export type FetchProductsQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string }, pagination?: { __typename?: 'PaginationType', currentPage: number, pageItems: number, totalItems: number, totalPages: number, totalFilteredItems: number } | null } };

export type FetchProductByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FetchProductByIdQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type UpdateProductMutationVariables = Exact<{
  id: Scalars['String']['input'];
  updateProductInput: UpdateProductInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type DeleteProductMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteProductMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type FetchAccountPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAccountPlansQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type FetchAllCurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAllCurrenciesQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type AdminFetchTransactionsQueryVariables = Exact<{
  params: QueryParamsInput;
}>;


export type AdminFetchTransactionsQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string }, pagination?: { __typename?: 'PaginationType', currentPage: number, pageItems: number, totalItems: number, totalPages: number, totalFilteredItems: number } | null } };

export type AdminFetchTransactionQueryVariables = Exact<{
  transactionId: Scalars['String']['input'];
}>;


export type AdminFetchTransactionQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type AdminFetchCustomerCountQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminFetchCustomerCountQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type AdminFetchDistributorCountQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminFetchDistributorCountQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type AdminFetchDeviceCountQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminFetchDeviceCountQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type AdminFetchTransactionCountQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminFetchTransactionCountQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type AdminDeleteTransactionMutationVariables = Exact<{
  transactionId: Scalars['String']['input'];
}>;


export type AdminDeleteTransactionMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type AdminFetchUsdcTransactionsSumQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminFetchUsdcTransactionsSumQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type AdminFetchUssdTransactionsSumQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminFetchUssdTransactionsSumQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type AdminFetchPurchasedDevicesCountQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminFetchPurchasedDevicesCountQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type AdminFetchTotalRevenueQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminFetchTotalRevenueQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type GetCurrentAdminProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentAdminProfileQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type UpdateAdminProfileMutationVariables = Exact<{
  fullName: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type UpdateAdminProfileMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type SendPasswordChangeOtpMutationVariables = Exact<{ [key: string]: never; }>;


export type SendPasswordChangeOtpMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type ChangeAdminPasswordMutationVariables = Exact<{
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  otpCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChangeAdminPasswordMutation = { __typename?: 'Mutation', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type AdminFetchActivationDebugTracesQueryVariables = Exact<{
  params: QueryParamsInput;
}>;


export type AdminFetchActivationDebugTracesQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string }, pagination?: { __typename?: 'PaginationType', currentPage: number, pageItems: number, totalItems: number, totalPages: number, totalFilteredItems: number } | null } };

export type AdminFetchActivationDebugTraceQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminFetchActivationDebugTraceQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type AdminFetchProcessedCircleWebhooksQueryVariables = Exact<{
  params: QueryParamsInput;
}>;


export type AdminFetchProcessedCircleWebhooksQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string }, pagination?: { __typename?: 'PaginationType', currentPage: number, pageItems: number, totalItems: number, totalPages: number, totalFilteredItems: number } | null } };

export type AdminFetchProcessedCircleWebhookQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminFetchProcessedCircleWebhookQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };

export type AdminFetchProcessedCircleWebhookByTxHashQueryVariables = Exact<{
  blockchain: Scalars['String']['input'];
  txHash: Scalars['String']['input'];
}>;


export type AdminFetchProcessedCircleWebhookByTxHashQuery = { __typename?: 'Query', data: { __typename?: 'DefaultResponse', payload?: any | null, alert: { __typename?: 'AlertType', type: string, message: string } } };


export const CreateAccountPlanDocument = gql`
    mutation CreateAccountPlan($createAccountPlanInput: CreateAccountPlanInput!) {
  data: createAccountPlan(createAccountPlanInput: $createAccountPlanInput) {
    alert {
      type
      message
    }
    payload
  }
}
    `;
export type CreateAccountPlanMutationFn = Apollo.MutationFunction<CreateAccountPlanMutation, CreateAccountPlanMutationVariables>;

/**
 * __useCreateAccountPlanMutation__
 *
 * To run a mutation, you first call `useCreateAccountPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountPlanMutation, { data, loading, error }] = useCreateAccountPlanMutation({
 *   variables: {
 *      createAccountPlanInput: // value for 'createAccountPlanInput'
 *   },
 * });
 */
export function useCreateAccountPlanMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountPlanMutation, CreateAccountPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountPlanMutation, CreateAccountPlanMutationVariables>(CreateAccountPlanDocument, options);
      }
export type CreateAccountPlanMutationHookResult = ReturnType<typeof useCreateAccountPlanMutation>;
export type CreateAccountPlanMutationResult = Apollo.MutationResult<CreateAccountPlanMutation>;
export type CreateAccountPlanMutationOptions = Apollo.BaseMutationOptions<CreateAccountPlanMutation, CreateAccountPlanMutationVariables>;
export const UpdateAccountPlanDocument = gql`
    mutation UpdateAccountPlan($accountPlanId: String!, $updateAccountPlanInput: UpdateAccountPlanInput!) {
  data: updateAccountPlan(
    accountPlanId: $accountPlanId
    updateAccountPlanInput: $updateAccountPlanInput
  ) {
    alert {
      type
      message
    }
    payload
  }
}
    `;
export type UpdateAccountPlanMutationFn = Apollo.MutationFunction<UpdateAccountPlanMutation, UpdateAccountPlanMutationVariables>;

/**
 * __useUpdateAccountPlanMutation__
 *
 * To run a mutation, you first call `useUpdateAccountPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountPlanMutation, { data, loading, error }] = useUpdateAccountPlanMutation({
 *   variables: {
 *      accountPlanId: // value for 'accountPlanId'
 *      updateAccountPlanInput: // value for 'updateAccountPlanInput'
 *   },
 * });
 */
export function useUpdateAccountPlanMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountPlanMutation, UpdateAccountPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountPlanMutation, UpdateAccountPlanMutationVariables>(UpdateAccountPlanDocument, options);
      }
export type UpdateAccountPlanMutationHookResult = ReturnType<typeof useUpdateAccountPlanMutation>;
export type UpdateAccountPlanMutationResult = Apollo.MutationResult<UpdateAccountPlanMutation>;
export type UpdateAccountPlanMutationOptions = Apollo.BaseMutationOptions<UpdateAccountPlanMutation, UpdateAccountPlanMutationVariables>;
export const DeleteAccountPlanDocument = gql`
    mutation DeleteAccountPlan($accountPlanId: String!) {
  data: deleteAccountPlan(accountPlanId: $accountPlanId) {
    alert {
      type
      message
    }
    payload
  }
}
    `;
export type DeleteAccountPlanMutationFn = Apollo.MutationFunction<DeleteAccountPlanMutation, DeleteAccountPlanMutationVariables>;

/**
 * __useDeleteAccountPlanMutation__
 *
 * To run a mutation, you first call `useDeleteAccountPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountPlanMutation, { data, loading, error }] = useDeleteAccountPlanMutation({
 *   variables: {
 *      accountPlanId: // value for 'accountPlanId'
 *   },
 * });
 */
export function useDeleteAccountPlanMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountPlanMutation, DeleteAccountPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountPlanMutation, DeleteAccountPlanMutationVariables>(DeleteAccountPlanDocument, options);
      }
export type DeleteAccountPlanMutationHookResult = ReturnType<typeof useDeleteAccountPlanMutation>;
export type DeleteAccountPlanMutationResult = Apollo.MutationResult<DeleteAccountPlanMutation>;
export type DeleteAccountPlanMutationOptions = Apollo.BaseMutationOptions<DeleteAccountPlanMutation, DeleteAccountPlanMutationVariables>;
export const AdminFetchCustomersDocument = gql`
    query AdminFetchCustomers($params: QueryParamsInput!) {
  data: adminFetchCustomers(params: $params) {
    alert {
      message
      type
    }
    payload
    pagination {
      currentPage
      pageItems
      totalItems
      totalPages
      totalFilteredItems
    }
  }
}
    `;

/**
 * __useAdminFetchCustomersQuery__
 *
 * To run a query within a React component, call `useAdminFetchCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchCustomersQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAdminFetchCustomersQuery(baseOptions: Apollo.QueryHookOptions<AdminFetchCustomersQuery, AdminFetchCustomersQueryVariables> & ({ variables: AdminFetchCustomersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFetchCustomersQuery, AdminFetchCustomersQueryVariables>(AdminFetchCustomersDocument, options);
      }
export function useAdminFetchCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFetchCustomersQuery, AdminFetchCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFetchCustomersQuery, AdminFetchCustomersQueryVariables>(AdminFetchCustomersDocument, options);
        }
export function useAdminFetchCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFetchCustomersQuery, AdminFetchCustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFetchCustomersQuery, AdminFetchCustomersQueryVariables>(AdminFetchCustomersDocument, options);
        }
export type AdminFetchCustomersQueryHookResult = ReturnType<typeof useAdminFetchCustomersQuery>;
export type AdminFetchCustomersLazyQueryHookResult = ReturnType<typeof useAdminFetchCustomersLazyQuery>;
export type AdminFetchCustomersSuspenseQueryHookResult = ReturnType<typeof useAdminFetchCustomersSuspenseQuery>;
export type AdminFetchCustomersQueryResult = Apollo.QueryResult<AdminFetchCustomersQuery, AdminFetchCustomersQueryVariables>;
export const AdminCreateCustomerDocument = gql`
    mutation AdminCreateCustomer($createCustomerInput: AddCustomerInput!) {
  data: adminCreateCustomer(createCustomerInput: $createCustomerInput) {
    alert {
      message
      type
    }
  }
}
    `;
export type AdminCreateCustomerMutationFn = Apollo.MutationFunction<AdminCreateCustomerMutation, AdminCreateCustomerMutationVariables>;

/**
 * __useAdminCreateCustomerMutation__
 *
 * To run a mutation, you first call `useAdminCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateCustomerMutation, { data, loading, error }] = useAdminCreateCustomerMutation({
 *   variables: {
 *      createCustomerInput: // value for 'createCustomerInput'
 *   },
 * });
 */
export function useAdminCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateCustomerMutation, AdminCreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateCustomerMutation, AdminCreateCustomerMutationVariables>(AdminCreateCustomerDocument, options);
      }
export type AdminCreateCustomerMutationHookResult = ReturnType<typeof useAdminCreateCustomerMutation>;
export type AdminCreateCustomerMutationResult = Apollo.MutationResult<AdminCreateCustomerMutation>;
export type AdminCreateCustomerMutationOptions = Apollo.BaseMutationOptions<AdminCreateCustomerMutation, AdminCreateCustomerMutationVariables>;
export const FetchCustomerByIdDocument = gql`
    query FetchCustomerById($customerId: String!) {
  data: fetchCustomer(customerId: $customerId) {
    alert {
      message
      type
    }
    payload
  }
}
    `;

/**
 * __useFetchCustomerByIdQuery__
 *
 * To run a query within a React component, call `useFetchCustomerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomerByIdQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useFetchCustomerByIdQuery(baseOptions: Apollo.QueryHookOptions<FetchCustomerByIdQuery, FetchCustomerByIdQueryVariables> & ({ variables: FetchCustomerByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomerByIdQuery, FetchCustomerByIdQueryVariables>(FetchCustomerByIdDocument, options);
      }
export function useFetchCustomerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomerByIdQuery, FetchCustomerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomerByIdQuery, FetchCustomerByIdQueryVariables>(FetchCustomerByIdDocument, options);
        }
export function useFetchCustomerByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchCustomerByIdQuery, FetchCustomerByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchCustomerByIdQuery, FetchCustomerByIdQueryVariables>(FetchCustomerByIdDocument, options);
        }
export type FetchCustomerByIdQueryHookResult = ReturnType<typeof useFetchCustomerByIdQuery>;
export type FetchCustomerByIdLazyQueryHookResult = ReturnType<typeof useFetchCustomerByIdLazyQuery>;
export type FetchCustomerByIdSuspenseQueryHookResult = ReturnType<typeof useFetchCustomerByIdSuspenseQuery>;
export type FetchCustomerByIdQueryResult = Apollo.QueryResult<FetchCustomerByIdQuery, FetchCustomerByIdQueryVariables>;
export const AdminUpdateCustomerDocument = gql`
    mutation AdminUpdateCustomer($customerId: String!, $updateCustomerInput: UpdateCustomerInput!) {
  data: adminUpdateCustomer(
    customerId: $customerId
    updateCustomerInput: $updateCustomerInput
  ) {
    alert {
      message
      type
    }
  }
}
    `;
export type AdminUpdateCustomerMutationFn = Apollo.MutationFunction<AdminUpdateCustomerMutation, AdminUpdateCustomerMutationVariables>;

/**
 * __useAdminUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useAdminUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateCustomerMutation, { data, loading, error }] = useAdminUpdateCustomerMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      updateCustomerInput: // value for 'updateCustomerInput'
 *   },
 * });
 */
export function useAdminUpdateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateCustomerMutation, AdminUpdateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateCustomerMutation, AdminUpdateCustomerMutationVariables>(AdminUpdateCustomerDocument, options);
      }
export type AdminUpdateCustomerMutationHookResult = ReturnType<typeof useAdminUpdateCustomerMutation>;
export type AdminUpdateCustomerMutationResult = Apollo.MutationResult<AdminUpdateCustomerMutation>;
export type AdminUpdateCustomerMutationOptions = Apollo.BaseMutationOptions<AdminUpdateCustomerMutation, AdminUpdateCustomerMutationVariables>;
export const AdminDeleteCustomerDocument = gql`
    mutation AdminDeleteCustomer($customerId: String!) {
  data: adminDeleteCustomer(customerId: $customerId) {
    alert {
      message
      type
    }
  }
}
    `;
export type AdminDeleteCustomerMutationFn = Apollo.MutationFunction<AdminDeleteCustomerMutation, AdminDeleteCustomerMutationVariables>;

/**
 * __useAdminDeleteCustomerMutation__
 *
 * To run a mutation, you first call `useAdminDeleteCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteCustomerMutation, { data, loading, error }] = useAdminDeleteCustomerMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useAdminDeleteCustomerMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteCustomerMutation, AdminDeleteCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteCustomerMutation, AdminDeleteCustomerMutationVariables>(AdminDeleteCustomerDocument, options);
      }
export type AdminDeleteCustomerMutationHookResult = ReturnType<typeof useAdminDeleteCustomerMutation>;
export type AdminDeleteCustomerMutationResult = Apollo.MutationResult<AdminDeleteCustomerMutation>;
export type AdminDeleteCustomerMutationOptions = Apollo.BaseMutationOptions<AdminDeleteCustomerMutation, AdminDeleteCustomerMutationVariables>;
export const GetAdminDashboardMetricsDocument = gql`
    query GetAdminDashboardMetrics($queryInput: MetricsQueryInput) {
  data: adminGetDashboardMetrics(queryInput: $queryInput) {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useGetAdminDashboardMetricsQuery__
 *
 * To run a query within a React component, call `useGetAdminDashboardMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminDashboardMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminDashboardMetricsQuery({
 *   variables: {
 *      queryInput: // value for 'queryInput'
 *   },
 * });
 */
export function useGetAdminDashboardMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminDashboardMetricsQuery, GetAdminDashboardMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminDashboardMetricsQuery, GetAdminDashboardMetricsQueryVariables>(GetAdminDashboardMetricsDocument, options);
      }
export function useGetAdminDashboardMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminDashboardMetricsQuery, GetAdminDashboardMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminDashboardMetricsQuery, GetAdminDashboardMetricsQueryVariables>(GetAdminDashboardMetricsDocument, options);
        }
export function useGetAdminDashboardMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminDashboardMetricsQuery, GetAdminDashboardMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminDashboardMetricsQuery, GetAdminDashboardMetricsQueryVariables>(GetAdminDashboardMetricsDocument, options);
        }
export type GetAdminDashboardMetricsQueryHookResult = ReturnType<typeof useGetAdminDashboardMetricsQuery>;
export type GetAdminDashboardMetricsLazyQueryHookResult = ReturnType<typeof useGetAdminDashboardMetricsLazyQuery>;
export type GetAdminDashboardMetricsSuspenseQueryHookResult = ReturnType<typeof useGetAdminDashboardMetricsSuspenseQuery>;
export type GetAdminDashboardMetricsQueryResult = Apollo.QueryResult<GetAdminDashboardMetricsQuery, GetAdminDashboardMetricsQueryVariables>;
export const AddDeviceBrandDocument = gql`
    mutation AddDeviceBrand($addDeviceBrandInput: AddDeviceBrandInput!) {
  data: addDeviceBrand(addDeviceBrandInput: $addDeviceBrandInput) {
    alert {
      message
      type
    }
  }
}
    `;
export type AddDeviceBrandMutationFn = Apollo.MutationFunction<AddDeviceBrandMutation, AddDeviceBrandMutationVariables>;

/**
 * __useAddDeviceBrandMutation__
 *
 * To run a mutation, you first call `useAddDeviceBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDeviceBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDeviceBrandMutation, { data, loading, error }] = useAddDeviceBrandMutation({
 *   variables: {
 *      addDeviceBrandInput: // value for 'addDeviceBrandInput'
 *   },
 * });
 */
export function useAddDeviceBrandMutation(baseOptions?: Apollo.MutationHookOptions<AddDeviceBrandMutation, AddDeviceBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDeviceBrandMutation, AddDeviceBrandMutationVariables>(AddDeviceBrandDocument, options);
      }
export type AddDeviceBrandMutationHookResult = ReturnType<typeof useAddDeviceBrandMutation>;
export type AddDeviceBrandMutationResult = Apollo.MutationResult<AddDeviceBrandMutation>;
export type AddDeviceBrandMutationOptions = Apollo.BaseMutationOptions<AddDeviceBrandMutation, AddDeviceBrandMutationVariables>;
export const FetchDeviceBrandsDocument = gql`
    query FetchDeviceBrands($params: QueryParamsInput!) {
  data: adminFetchDeviceBrands(params: $params) {
    alert {
      message
      type
    }
    payload
    pagination {
      currentPage
      pageItems
      totalItems
      totalPages
      totalFilteredItems
    }
  }
}
    `;

/**
 * __useFetchDeviceBrandsQuery__
 *
 * To run a query within a React component, call `useFetchDeviceBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDeviceBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDeviceBrandsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useFetchDeviceBrandsQuery(baseOptions: Apollo.QueryHookOptions<FetchDeviceBrandsQuery, FetchDeviceBrandsQueryVariables> & ({ variables: FetchDeviceBrandsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDeviceBrandsQuery, FetchDeviceBrandsQueryVariables>(FetchDeviceBrandsDocument, options);
      }
export function useFetchDeviceBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDeviceBrandsQuery, FetchDeviceBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDeviceBrandsQuery, FetchDeviceBrandsQueryVariables>(FetchDeviceBrandsDocument, options);
        }
export function useFetchDeviceBrandsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchDeviceBrandsQuery, FetchDeviceBrandsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchDeviceBrandsQuery, FetchDeviceBrandsQueryVariables>(FetchDeviceBrandsDocument, options);
        }
export type FetchDeviceBrandsQueryHookResult = ReturnType<typeof useFetchDeviceBrandsQuery>;
export type FetchDeviceBrandsLazyQueryHookResult = ReturnType<typeof useFetchDeviceBrandsLazyQuery>;
export type FetchDeviceBrandsSuspenseQueryHookResult = ReturnType<typeof useFetchDeviceBrandsSuspenseQuery>;
export type FetchDeviceBrandsQueryResult = Apollo.QueryResult<FetchDeviceBrandsQuery, FetchDeviceBrandsQueryVariables>;
export const EditDeviceBrandDocument = gql`
    mutation EditDeviceBrand($deviceBrandId: String!, $editDeviceBrandInput: EditDeviceBrandInput!) {
  data: editDeviceBrand(
    deviceBrandId: $deviceBrandId
    editDeviceBrandInput: $editDeviceBrandInput
  ) {
    alert {
      message
      type
    }
  }
}
    `;
export type EditDeviceBrandMutationFn = Apollo.MutationFunction<EditDeviceBrandMutation, EditDeviceBrandMutationVariables>;

/**
 * __useEditDeviceBrandMutation__
 *
 * To run a mutation, you first call `useEditDeviceBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDeviceBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDeviceBrandMutation, { data, loading, error }] = useEditDeviceBrandMutation({
 *   variables: {
 *      deviceBrandId: // value for 'deviceBrandId'
 *      editDeviceBrandInput: // value for 'editDeviceBrandInput'
 *   },
 * });
 */
export function useEditDeviceBrandMutation(baseOptions?: Apollo.MutationHookOptions<EditDeviceBrandMutation, EditDeviceBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDeviceBrandMutation, EditDeviceBrandMutationVariables>(EditDeviceBrandDocument, options);
      }
export type EditDeviceBrandMutationHookResult = ReturnType<typeof useEditDeviceBrandMutation>;
export type EditDeviceBrandMutationResult = Apollo.MutationResult<EditDeviceBrandMutation>;
export type EditDeviceBrandMutationOptions = Apollo.BaseMutationOptions<EditDeviceBrandMutation, EditDeviceBrandMutationVariables>;
export const DeleteDeviceBrandDocument = gql`
    mutation DeleteDeviceBrand($deviceBrandId: String!) {
  data: deleteDeviceBrand(deviceBrandId: $deviceBrandId) {
    alert {
      message
      type
    }
  }
}
    `;
export type DeleteDeviceBrandMutationFn = Apollo.MutationFunction<DeleteDeviceBrandMutation, DeleteDeviceBrandMutationVariables>;

/**
 * __useDeleteDeviceBrandMutation__
 *
 * To run a mutation, you first call `useDeleteDeviceBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeviceBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeviceBrandMutation, { data, loading, error }] = useDeleteDeviceBrandMutation({
 *   variables: {
 *      deviceBrandId: // value for 'deviceBrandId'
 *   },
 * });
 */
export function useDeleteDeviceBrandMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeviceBrandMutation, DeleteDeviceBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeviceBrandMutation, DeleteDeviceBrandMutationVariables>(DeleteDeviceBrandDocument, options);
      }
export type DeleteDeviceBrandMutationHookResult = ReturnType<typeof useDeleteDeviceBrandMutation>;
export type DeleteDeviceBrandMutationResult = Apollo.MutationResult<DeleteDeviceBrandMutation>;
export type DeleteDeviceBrandMutationOptions = Apollo.BaseMutationOptions<DeleteDeviceBrandMutation, DeleteDeviceBrandMutationVariables>;
export const AddDeviceModelDocument = gql`
    mutation AddDeviceModel($addDeviceModelInput: AddDeviceModelInput!) {
  data: addDeviceModel(addDeviceModelInput: $addDeviceModelInput) {
    alert {
      message
      type
    }
  }
}
    `;
export type AddDeviceModelMutationFn = Apollo.MutationFunction<AddDeviceModelMutation, AddDeviceModelMutationVariables>;

/**
 * __useAddDeviceModelMutation__
 *
 * To run a mutation, you first call `useAddDeviceModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDeviceModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDeviceModelMutation, { data, loading, error }] = useAddDeviceModelMutation({
 *   variables: {
 *      addDeviceModelInput: // value for 'addDeviceModelInput'
 *   },
 * });
 */
export function useAddDeviceModelMutation(baseOptions?: Apollo.MutationHookOptions<AddDeviceModelMutation, AddDeviceModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDeviceModelMutation, AddDeviceModelMutationVariables>(AddDeviceModelDocument, options);
      }
export type AddDeviceModelMutationHookResult = ReturnType<typeof useAddDeviceModelMutation>;
export type AddDeviceModelMutationResult = Apollo.MutationResult<AddDeviceModelMutation>;
export type AddDeviceModelMutationOptions = Apollo.BaseMutationOptions<AddDeviceModelMutation, AddDeviceModelMutationVariables>;
export const FetchDeviceModelsDocument = gql`
    query FetchDeviceModels($params: QueryParamsInput!) {
  data: adminFetchDeviceModels(params: $params) {
    alert {
      message
      type
    }
    payload
    pagination {
      currentPage
      pageItems
      totalItems
      totalPages
      totalFilteredItems
    }
  }
}
    `;

/**
 * __useFetchDeviceModelsQuery__
 *
 * To run a query within a React component, call `useFetchDeviceModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDeviceModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDeviceModelsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useFetchDeviceModelsQuery(baseOptions: Apollo.QueryHookOptions<FetchDeviceModelsQuery, FetchDeviceModelsQueryVariables> & ({ variables: FetchDeviceModelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDeviceModelsQuery, FetchDeviceModelsQueryVariables>(FetchDeviceModelsDocument, options);
      }
export function useFetchDeviceModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDeviceModelsQuery, FetchDeviceModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDeviceModelsQuery, FetchDeviceModelsQueryVariables>(FetchDeviceModelsDocument, options);
        }
export function useFetchDeviceModelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchDeviceModelsQuery, FetchDeviceModelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchDeviceModelsQuery, FetchDeviceModelsQueryVariables>(FetchDeviceModelsDocument, options);
        }
export type FetchDeviceModelsQueryHookResult = ReturnType<typeof useFetchDeviceModelsQuery>;
export type FetchDeviceModelsLazyQueryHookResult = ReturnType<typeof useFetchDeviceModelsLazyQuery>;
export type FetchDeviceModelsSuspenseQueryHookResult = ReturnType<typeof useFetchDeviceModelsSuspenseQuery>;
export type FetchDeviceModelsQueryResult = Apollo.QueryResult<FetchDeviceModelsQuery, FetchDeviceModelsQueryVariables>;
export const EditDeviceModelDocument = gql`
    mutation EditDeviceModel($deviceModelId: String!, $editDeviceModelInput: EditDeviceModelInput!) {
  data: editDeviceModel(
    deviceModelId: $deviceModelId
    editDeviceModelInput: $editDeviceModelInput
  ) {
    alert {
      message
      type
    }
  }
}
    `;
export type EditDeviceModelMutationFn = Apollo.MutationFunction<EditDeviceModelMutation, EditDeviceModelMutationVariables>;

/**
 * __useEditDeviceModelMutation__
 *
 * To run a mutation, you first call `useEditDeviceModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDeviceModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDeviceModelMutation, { data, loading, error }] = useEditDeviceModelMutation({
 *   variables: {
 *      deviceModelId: // value for 'deviceModelId'
 *      editDeviceModelInput: // value for 'editDeviceModelInput'
 *   },
 * });
 */
export function useEditDeviceModelMutation(baseOptions?: Apollo.MutationHookOptions<EditDeviceModelMutation, EditDeviceModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDeviceModelMutation, EditDeviceModelMutationVariables>(EditDeviceModelDocument, options);
      }
export type EditDeviceModelMutationHookResult = ReturnType<typeof useEditDeviceModelMutation>;
export type EditDeviceModelMutationResult = Apollo.MutationResult<EditDeviceModelMutation>;
export type EditDeviceModelMutationOptions = Apollo.BaseMutationOptions<EditDeviceModelMutation, EditDeviceModelMutationVariables>;
export const DeleteDeviceModelDocument = gql`
    mutation DeleteDeviceModel($deviceModelId: String!) {
  data: deleteDeviceModel(deviceModelId: $deviceModelId) {
    alert {
      message
      type
    }
  }
}
    `;
export type DeleteDeviceModelMutationFn = Apollo.MutationFunction<DeleteDeviceModelMutation, DeleteDeviceModelMutationVariables>;

/**
 * __useDeleteDeviceModelMutation__
 *
 * To run a mutation, you first call `useDeleteDeviceModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeviceModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeviceModelMutation, { data, loading, error }] = useDeleteDeviceModelMutation({
 *   variables: {
 *      deviceModelId: // value for 'deviceModelId'
 *   },
 * });
 */
export function useDeleteDeviceModelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeviceModelMutation, DeleteDeviceModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeviceModelMutation, DeleteDeviceModelMutationVariables>(DeleteDeviceModelDocument, options);
      }
export type DeleteDeviceModelMutationHookResult = ReturnType<typeof useDeleteDeviceModelMutation>;
export type DeleteDeviceModelMutationResult = Apollo.MutationResult<DeleteDeviceModelMutation>;
export type DeleteDeviceModelMutationOptions = Apollo.BaseMutationOptions<DeleteDeviceModelMutation, DeleteDeviceModelMutationVariables>;
export const AdminFetchDevicesDocument = gql`
    query AdminFetchDevices($params: QueryParamsInput!) {
  data: adminFetchDevices(params: $params) {
    alert {
      type
      message
    }
    payload
    pagination {
      currentPage
      pageItems
      totalItems
      totalPages
      totalFilteredItems
    }
  }
}
    `;

/**
 * __useAdminFetchDevicesQuery__
 *
 * To run a query within a React component, call `useAdminFetchDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchDevicesQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAdminFetchDevicesQuery(baseOptions: Apollo.QueryHookOptions<AdminFetchDevicesQuery, AdminFetchDevicesQueryVariables> & ({ variables: AdminFetchDevicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFetchDevicesQuery, AdminFetchDevicesQueryVariables>(AdminFetchDevicesDocument, options);
      }
export function useAdminFetchDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFetchDevicesQuery, AdminFetchDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFetchDevicesQuery, AdminFetchDevicesQueryVariables>(AdminFetchDevicesDocument, options);
        }
export function useAdminFetchDevicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFetchDevicesQuery, AdminFetchDevicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFetchDevicesQuery, AdminFetchDevicesQueryVariables>(AdminFetchDevicesDocument, options);
        }
export type AdminFetchDevicesQueryHookResult = ReturnType<typeof useAdminFetchDevicesQuery>;
export type AdminFetchDevicesLazyQueryHookResult = ReturnType<typeof useAdminFetchDevicesLazyQuery>;
export type AdminFetchDevicesSuspenseQueryHookResult = ReturnType<typeof useAdminFetchDevicesSuspenseQuery>;
export type AdminFetchDevicesQueryResult = Apollo.QueryResult<AdminFetchDevicesQuery, AdminFetchDevicesQueryVariables>;
export const FetchModelsByBrandDocument = gql`
    query FetchModelsByBrand($brandId: String!) {
  data: fetchModelsByBrand(brandId: $brandId) {
    alert {
      message
      type
    }
    payload
  }
}
    `;

/**
 * __useFetchModelsByBrandQuery__
 *
 * To run a query within a React component, call `useFetchModelsByBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchModelsByBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchModelsByBrandQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useFetchModelsByBrandQuery(baseOptions: Apollo.QueryHookOptions<FetchModelsByBrandQuery, FetchModelsByBrandQueryVariables> & ({ variables: FetchModelsByBrandQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchModelsByBrandQuery, FetchModelsByBrandQueryVariables>(FetchModelsByBrandDocument, options);
      }
export function useFetchModelsByBrandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchModelsByBrandQuery, FetchModelsByBrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchModelsByBrandQuery, FetchModelsByBrandQueryVariables>(FetchModelsByBrandDocument, options);
        }
export function useFetchModelsByBrandSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchModelsByBrandQuery, FetchModelsByBrandQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchModelsByBrandQuery, FetchModelsByBrandQueryVariables>(FetchModelsByBrandDocument, options);
        }
export type FetchModelsByBrandQueryHookResult = ReturnType<typeof useFetchModelsByBrandQuery>;
export type FetchModelsByBrandLazyQueryHookResult = ReturnType<typeof useFetchModelsByBrandLazyQuery>;
export type FetchModelsByBrandSuspenseQueryHookResult = ReturnType<typeof useFetchModelsByBrandSuspenseQuery>;
export type FetchModelsByBrandQueryResult = Apollo.QueryResult<FetchModelsByBrandQuery, FetchModelsByBrandQueryVariables>;
export const AddDeviceDocument = gql`
    mutation AddDevice($addDeviceInput: AddDeviceInput!) {
  data: addDevice(addDeviceInput: $addDeviceInput) {
    alert {
      message
      type
    }
  }
}
    `;
export type AddDeviceMutationFn = Apollo.MutationFunction<AddDeviceMutation, AddDeviceMutationVariables>;

/**
 * __useAddDeviceMutation__
 *
 * To run a mutation, you first call `useAddDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDeviceMutation, { data, loading, error }] = useAddDeviceMutation({
 *   variables: {
 *      addDeviceInput: // value for 'addDeviceInput'
 *   },
 * });
 */
export function useAddDeviceMutation(baseOptions?: Apollo.MutationHookOptions<AddDeviceMutation, AddDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDeviceMutation, AddDeviceMutationVariables>(AddDeviceDocument, options);
      }
export type AddDeviceMutationHookResult = ReturnType<typeof useAddDeviceMutation>;
export type AddDeviceMutationResult = Apollo.MutationResult<AddDeviceMutation>;
export type AddDeviceMutationOptions = Apollo.BaseMutationOptions<AddDeviceMutation, AddDeviceMutationVariables>;
export const EditDeviceDocument = gql`
    mutation EditDevice($deviceId: String!, $editDeviceInput: EditDeviceInput!) {
  data: editDevice(deviceId: $deviceId, editDeviceInput: $editDeviceInput) {
    alert {
      message
      type
    }
  }
}
    `;
export type EditDeviceMutationFn = Apollo.MutationFunction<EditDeviceMutation, EditDeviceMutationVariables>;

/**
 * __useEditDeviceMutation__
 *
 * To run a mutation, you first call `useEditDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDeviceMutation, { data, loading, error }] = useEditDeviceMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      editDeviceInput: // value for 'editDeviceInput'
 *   },
 * });
 */
export function useEditDeviceMutation(baseOptions?: Apollo.MutationHookOptions<EditDeviceMutation, EditDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDeviceMutation, EditDeviceMutationVariables>(EditDeviceDocument, options);
      }
export type EditDeviceMutationHookResult = ReturnType<typeof useEditDeviceMutation>;
export type EditDeviceMutationResult = Apollo.MutationResult<EditDeviceMutation>;
export type EditDeviceMutationOptions = Apollo.BaseMutationOptions<EditDeviceMutation, EditDeviceMutationVariables>;
export const DeleteDevicesDocument = gql`
    mutation DeleteDevices($deviceIds: [String!]!) {
  data: deleteDevices(deviceIds: $deviceIds) {
    alert {
      message
      type
    }
  }
}
    `;
export type DeleteDevicesMutationFn = Apollo.MutationFunction<DeleteDevicesMutation, DeleteDevicesMutationVariables>;

/**
 * __useDeleteDevicesMutation__
 *
 * To run a mutation, you first call `useDeleteDevicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDevicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDevicesMutation, { data, loading, error }] = useDeleteDevicesMutation({
 *   variables: {
 *      deviceIds: // value for 'deviceIds'
 *   },
 * });
 */
export function useDeleteDevicesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDevicesMutation, DeleteDevicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDevicesMutation, DeleteDevicesMutationVariables>(DeleteDevicesDocument, options);
      }
export type DeleteDevicesMutationHookResult = ReturnType<typeof useDeleteDevicesMutation>;
export type DeleteDevicesMutationResult = Apollo.MutationResult<DeleteDevicesMutation>;
export type DeleteDevicesMutationOptions = Apollo.BaseMutationOptions<DeleteDevicesMutation, DeleteDevicesMutationVariables>;
export const FetchDeviceDocument = gql`
    query FetchDevice($deviceId: String!) {
  data: fetchDevice(deviceId: $deviceId) {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useFetchDeviceQuery__
 *
 * To run a query within a React component, call `useFetchDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDeviceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDeviceQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useFetchDeviceQuery(baseOptions: Apollo.QueryHookOptions<FetchDeviceQuery, FetchDeviceQueryVariables> & ({ variables: FetchDeviceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDeviceQuery, FetchDeviceQueryVariables>(FetchDeviceDocument, options);
      }
export function useFetchDeviceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDeviceQuery, FetchDeviceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDeviceQuery, FetchDeviceQueryVariables>(FetchDeviceDocument, options);
        }
export function useFetchDeviceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchDeviceQuery, FetchDeviceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchDeviceQuery, FetchDeviceQueryVariables>(FetchDeviceDocument, options);
        }
export type FetchDeviceQueryHookResult = ReturnType<typeof useFetchDeviceQuery>;
export type FetchDeviceLazyQueryHookResult = ReturnType<typeof useFetchDeviceLazyQuery>;
export type FetchDeviceSuspenseQueryHookResult = ReturnType<typeof useFetchDeviceSuspenseQuery>;
export type FetchDeviceQueryResult = Apollo.QueryResult<FetchDeviceQuery, FetchDeviceQueryVariables>;
export const AdminAddDevicesDocument = gql`
    mutation AdminAddDevices($addDevicesInput: [AddDeviceInput!]!) {
  data: adminAddDevices(addDevicesInput: $addDevicesInput) {
    alert {
      message
      type
    }
    payload
  }
}
    `;
export type AdminAddDevicesMutationFn = Apollo.MutationFunction<AdminAddDevicesMutation, AdminAddDevicesMutationVariables>;

/**
 * __useAdminAddDevicesMutation__
 *
 * To run a mutation, you first call `useAdminAddDevicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAddDevicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAddDevicesMutation, { data, loading, error }] = useAdminAddDevicesMutation({
 *   variables: {
 *      addDevicesInput: // value for 'addDevicesInput'
 *   },
 * });
 */
export function useAdminAddDevicesMutation(baseOptions?: Apollo.MutationHookOptions<AdminAddDevicesMutation, AdminAddDevicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAddDevicesMutation, AdminAddDevicesMutationVariables>(AdminAddDevicesDocument, options);
      }
export type AdminAddDevicesMutationHookResult = ReturnType<typeof useAdminAddDevicesMutation>;
export type AdminAddDevicesMutationResult = Apollo.MutationResult<AdminAddDevicesMutation>;
export type AdminAddDevicesMutationOptions = Apollo.BaseMutationOptions<AdminAddDevicesMutation, AdminAddDevicesMutationVariables>;
export const AdminFetchAvailableDevicesDocument = gql`
    query AdminFetchAvailableDevices($params: QueryParamsInput!) {
  data: adminFetchAvailableDevices(params: $params) {
    alert {
      message
      type
    }
    payload
  }
}
    `;

/**
 * __useAdminFetchAvailableDevicesQuery__
 *
 * To run a query within a React component, call `useAdminFetchAvailableDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchAvailableDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchAvailableDevicesQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAdminFetchAvailableDevicesQuery(baseOptions: Apollo.QueryHookOptions<AdminFetchAvailableDevicesQuery, AdminFetchAvailableDevicesQueryVariables> & ({ variables: AdminFetchAvailableDevicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFetchAvailableDevicesQuery, AdminFetchAvailableDevicesQueryVariables>(AdminFetchAvailableDevicesDocument, options);
      }
export function useAdminFetchAvailableDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFetchAvailableDevicesQuery, AdminFetchAvailableDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFetchAvailableDevicesQuery, AdminFetchAvailableDevicesQueryVariables>(AdminFetchAvailableDevicesDocument, options);
        }
export function useAdminFetchAvailableDevicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFetchAvailableDevicesQuery, AdminFetchAvailableDevicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFetchAvailableDevicesQuery, AdminFetchAvailableDevicesQueryVariables>(AdminFetchAvailableDevicesDocument, options);
        }
export type AdminFetchAvailableDevicesQueryHookResult = ReturnType<typeof useAdminFetchAvailableDevicesQuery>;
export type AdminFetchAvailableDevicesLazyQueryHookResult = ReturnType<typeof useAdminFetchAvailableDevicesLazyQuery>;
export type AdminFetchAvailableDevicesSuspenseQueryHookResult = ReturnType<typeof useAdminFetchAvailableDevicesSuspenseQuery>;
export type AdminFetchAvailableDevicesQueryResult = Apollo.QueryResult<AdminFetchAvailableDevicesQuery, AdminFetchAvailableDevicesQueryVariables>;
export const FetchDistributorRegistrationsDocument = gql`
    query FetchDistributorRegistrations($params: QueryParamsInput!) {
  data: fetchDistributorRegistrations(params: $params) {
    payload
    alert {
      message
      type
    }
    pagination {
      currentPage
      pageItems
      totalItems
      totalPages
      totalFilteredItems
    }
  }
}
    `;

/**
 * __useFetchDistributorRegistrationsQuery__
 *
 * To run a query within a React component, call `useFetchDistributorRegistrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDistributorRegistrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDistributorRegistrationsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useFetchDistributorRegistrationsQuery(baseOptions: Apollo.QueryHookOptions<FetchDistributorRegistrationsQuery, FetchDistributorRegistrationsQueryVariables> & ({ variables: FetchDistributorRegistrationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDistributorRegistrationsQuery, FetchDistributorRegistrationsQueryVariables>(FetchDistributorRegistrationsDocument, options);
      }
export function useFetchDistributorRegistrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDistributorRegistrationsQuery, FetchDistributorRegistrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDistributorRegistrationsQuery, FetchDistributorRegistrationsQueryVariables>(FetchDistributorRegistrationsDocument, options);
        }
export function useFetchDistributorRegistrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchDistributorRegistrationsQuery, FetchDistributorRegistrationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchDistributorRegistrationsQuery, FetchDistributorRegistrationsQueryVariables>(FetchDistributorRegistrationsDocument, options);
        }
export type FetchDistributorRegistrationsQueryHookResult = ReturnType<typeof useFetchDistributorRegistrationsQuery>;
export type FetchDistributorRegistrationsLazyQueryHookResult = ReturnType<typeof useFetchDistributorRegistrationsLazyQuery>;
export type FetchDistributorRegistrationsSuspenseQueryHookResult = ReturnType<typeof useFetchDistributorRegistrationsSuspenseQuery>;
export type FetchDistributorRegistrationsQueryResult = Apollo.QueryResult<FetchDistributorRegistrationsQuery, FetchDistributorRegistrationsQueryVariables>;
export const FetchDistributorRegistrationByIdDocument = gql`
    query FetchDistributorRegistrationById($id: String!) {
  data: fetchDistributorRegistrationById(id: $id) {
    payload
    alert {
      message
      type
    }
  }
}
    `;

/**
 * __useFetchDistributorRegistrationByIdQuery__
 *
 * To run a query within a React component, call `useFetchDistributorRegistrationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDistributorRegistrationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDistributorRegistrationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchDistributorRegistrationByIdQuery(baseOptions: Apollo.QueryHookOptions<FetchDistributorRegistrationByIdQuery, FetchDistributorRegistrationByIdQueryVariables> & ({ variables: FetchDistributorRegistrationByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDistributorRegistrationByIdQuery, FetchDistributorRegistrationByIdQueryVariables>(FetchDistributorRegistrationByIdDocument, options);
      }
export function useFetchDistributorRegistrationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDistributorRegistrationByIdQuery, FetchDistributorRegistrationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDistributorRegistrationByIdQuery, FetchDistributorRegistrationByIdQueryVariables>(FetchDistributorRegistrationByIdDocument, options);
        }
export function useFetchDistributorRegistrationByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchDistributorRegistrationByIdQuery, FetchDistributorRegistrationByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchDistributorRegistrationByIdQuery, FetchDistributorRegistrationByIdQueryVariables>(FetchDistributorRegistrationByIdDocument, options);
        }
export type FetchDistributorRegistrationByIdQueryHookResult = ReturnType<typeof useFetchDistributorRegistrationByIdQuery>;
export type FetchDistributorRegistrationByIdLazyQueryHookResult = ReturnType<typeof useFetchDistributorRegistrationByIdLazyQuery>;
export type FetchDistributorRegistrationByIdSuspenseQueryHookResult = ReturnType<typeof useFetchDistributorRegistrationByIdSuspenseQuery>;
export type FetchDistributorRegistrationByIdQueryResult = Apollo.QueryResult<FetchDistributorRegistrationByIdQuery, FetchDistributorRegistrationByIdQueryVariables>;
export const ApproveDistributorRegistrationDocument = gql`
    mutation ApproveDistributorRegistration($registrationId: String!) {
  data: approveDistributorRegistration(registrationId: $registrationId) {
    payload
    alert {
      message
      type
    }
  }
}
    `;
export type ApproveDistributorRegistrationMutationFn = Apollo.MutationFunction<ApproveDistributorRegistrationMutation, ApproveDistributorRegistrationMutationVariables>;

/**
 * __useApproveDistributorRegistrationMutation__
 *
 * To run a mutation, you first call `useApproveDistributorRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveDistributorRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveDistributorRegistrationMutation, { data, loading, error }] = useApproveDistributorRegistrationMutation({
 *   variables: {
 *      registrationId: // value for 'registrationId'
 *   },
 * });
 */
export function useApproveDistributorRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<ApproveDistributorRegistrationMutation, ApproveDistributorRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveDistributorRegistrationMutation, ApproveDistributorRegistrationMutationVariables>(ApproveDistributorRegistrationDocument, options);
      }
export type ApproveDistributorRegistrationMutationHookResult = ReturnType<typeof useApproveDistributorRegistrationMutation>;
export type ApproveDistributorRegistrationMutationResult = Apollo.MutationResult<ApproveDistributorRegistrationMutation>;
export type ApproveDistributorRegistrationMutationOptions = Apollo.BaseMutationOptions<ApproveDistributorRegistrationMutation, ApproveDistributorRegistrationMutationVariables>;
export const RejectDistributorRegistrationDocument = gql`
    mutation RejectDistributorRegistration($registrationId: String!, $reason: String!) {
  data: rejectDistributorRegistration(
    registrationId: $registrationId
    reason: $reason
  ) {
    payload
    alert {
      message
      type
    }
  }
}
    `;
export type RejectDistributorRegistrationMutationFn = Apollo.MutationFunction<RejectDistributorRegistrationMutation, RejectDistributorRegistrationMutationVariables>;

/**
 * __useRejectDistributorRegistrationMutation__
 *
 * To run a mutation, you first call `useRejectDistributorRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectDistributorRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectDistributorRegistrationMutation, { data, loading, error }] = useRejectDistributorRegistrationMutation({
 *   variables: {
 *      registrationId: // value for 'registrationId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRejectDistributorRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<RejectDistributorRegistrationMutation, RejectDistributorRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectDistributorRegistrationMutation, RejectDistributorRegistrationMutationVariables>(RejectDistributorRegistrationDocument, options);
      }
export type RejectDistributorRegistrationMutationHookResult = ReturnType<typeof useRejectDistributorRegistrationMutation>;
export type RejectDistributorRegistrationMutationResult = Apollo.MutationResult<RejectDistributorRegistrationMutation>;
export type RejectDistributorRegistrationMutationOptions = Apollo.BaseMutationOptions<RejectDistributorRegistrationMutation, RejectDistributorRegistrationMutationVariables>;
export const FetchAllDistributorsDocument = gql`
    query FetchAllDistributors($params: QueryParamsInput!) {
  data: fetchAllDistributors(params: $params) {
    payload
    alert {
      type
      message
    }
    pagination {
      currentPage
      pageItems
      totalItems
      totalPages
      totalFilteredItems
    }
  }
}
    `;

/**
 * __useFetchAllDistributorsQuery__
 *
 * To run a query within a React component, call `useFetchAllDistributorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllDistributorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllDistributorsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useFetchAllDistributorsQuery(baseOptions: Apollo.QueryHookOptions<FetchAllDistributorsQuery, FetchAllDistributorsQueryVariables> & ({ variables: FetchAllDistributorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllDistributorsQuery, FetchAllDistributorsQueryVariables>(FetchAllDistributorsDocument, options);
      }
export function useFetchAllDistributorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllDistributorsQuery, FetchAllDistributorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllDistributorsQuery, FetchAllDistributorsQueryVariables>(FetchAllDistributorsDocument, options);
        }
export function useFetchAllDistributorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchAllDistributorsQuery, FetchAllDistributorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAllDistributorsQuery, FetchAllDistributorsQueryVariables>(FetchAllDistributorsDocument, options);
        }
export type FetchAllDistributorsQueryHookResult = ReturnType<typeof useFetchAllDistributorsQuery>;
export type FetchAllDistributorsLazyQueryHookResult = ReturnType<typeof useFetchAllDistributorsLazyQuery>;
export type FetchAllDistributorsSuspenseQueryHookResult = ReturnType<typeof useFetchAllDistributorsSuspenseQuery>;
export type FetchAllDistributorsQueryResult = Apollo.QueryResult<FetchAllDistributorsQuery, FetchAllDistributorsQueryVariables>;
export const FetchDistributorCountriesDocument = gql`
    query FetchDistributorCountries {
  data: fetchDistributorCountries {
    payload
    alert {
      type
      message
    }
  }
}
    `;

/**
 * __useFetchDistributorCountriesQuery__
 *
 * To run a query within a React component, call `useFetchDistributorCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDistributorCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDistributorCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchDistributorCountriesQuery(baseOptions?: Apollo.QueryHookOptions<FetchDistributorCountriesQuery, FetchDistributorCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDistributorCountriesQuery, FetchDistributorCountriesQueryVariables>(FetchDistributorCountriesDocument, options);
      }
export function useFetchDistributorCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDistributorCountriesQuery, FetchDistributorCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDistributorCountriesQuery, FetchDistributorCountriesQueryVariables>(FetchDistributorCountriesDocument, options);
        }
export function useFetchDistributorCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchDistributorCountriesQuery, FetchDistributorCountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchDistributorCountriesQuery, FetchDistributorCountriesQueryVariables>(FetchDistributorCountriesDocument, options);
        }
export type FetchDistributorCountriesQueryHookResult = ReturnType<typeof useFetchDistributorCountriesQuery>;
export type FetchDistributorCountriesLazyQueryHookResult = ReturnType<typeof useFetchDistributorCountriesLazyQuery>;
export type FetchDistributorCountriesSuspenseQueryHookResult = ReturnType<typeof useFetchDistributorCountriesSuspenseQuery>;
export type FetchDistributorCountriesQueryResult = Apollo.QueryResult<FetchDistributorCountriesQuery, FetchDistributorCountriesQueryVariables>;
export const FetchDistributorAndRegistrationDocument = gql`
    query FetchDistributorAndRegistration($id: String!) {
  data: fetchDistributorAndRegistration(id: $id) {
    payload
    alert {
      type
      message
    }
  }
}
    `;

/**
 * __useFetchDistributorAndRegistrationQuery__
 *
 * To run a query within a React component, call `useFetchDistributorAndRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDistributorAndRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDistributorAndRegistrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchDistributorAndRegistrationQuery(baseOptions: Apollo.QueryHookOptions<FetchDistributorAndRegistrationQuery, FetchDistributorAndRegistrationQueryVariables> & ({ variables: FetchDistributorAndRegistrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDistributorAndRegistrationQuery, FetchDistributorAndRegistrationQueryVariables>(FetchDistributorAndRegistrationDocument, options);
      }
export function useFetchDistributorAndRegistrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDistributorAndRegistrationQuery, FetchDistributorAndRegistrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDistributorAndRegistrationQuery, FetchDistributorAndRegistrationQueryVariables>(FetchDistributorAndRegistrationDocument, options);
        }
export function useFetchDistributorAndRegistrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchDistributorAndRegistrationQuery, FetchDistributorAndRegistrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchDistributorAndRegistrationQuery, FetchDistributorAndRegistrationQueryVariables>(FetchDistributorAndRegistrationDocument, options);
        }
export type FetchDistributorAndRegistrationQueryHookResult = ReturnType<typeof useFetchDistributorAndRegistrationQuery>;
export type FetchDistributorAndRegistrationLazyQueryHookResult = ReturnType<typeof useFetchDistributorAndRegistrationLazyQuery>;
export type FetchDistributorAndRegistrationSuspenseQueryHookResult = ReturnType<typeof useFetchDistributorAndRegistrationSuspenseQuery>;
export type FetchDistributorAndRegistrationQueryResult = Apollo.QueryResult<FetchDistributorAndRegistrationQuery, FetchDistributorAndRegistrationQueryVariables>;
export const UpdateDistributorDocument = gql`
    mutation UpdateDistributor($id: String!, $input: UpdateDistributorInput!) {
  data: updateDistributor(id: $id, input: $input) {
    alert {
      type
      message
    }
    payload
  }
}
    `;
export type UpdateDistributorMutationFn = Apollo.MutationFunction<UpdateDistributorMutation, UpdateDistributorMutationVariables>;

/**
 * __useUpdateDistributorMutation__
 *
 * To run a mutation, you first call `useUpdateDistributorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDistributorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDistributorMutation, { data, loading, error }] = useUpdateDistributorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDistributorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDistributorMutation, UpdateDistributorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDistributorMutation, UpdateDistributorMutationVariables>(UpdateDistributorDocument, options);
      }
export type UpdateDistributorMutationHookResult = ReturnType<typeof useUpdateDistributorMutation>;
export type UpdateDistributorMutationResult = Apollo.MutationResult<UpdateDistributorMutation>;
export type UpdateDistributorMutationOptions = Apollo.BaseMutationOptions<UpdateDistributorMutation, UpdateDistributorMutationVariables>;
export const AdminFetchDonationNetworksDocument = gql`
    query AdminFetchDonationNetworks($params: QueryParamsInput!) {
  data: adminFetchDonationNetworks(params: $params) {
    alert {
      type
      message
    }
    payload
    pagination {
      totalItems
      totalFilteredItems
      totalPages
      currentPage
      pageItems
    }
  }
}
    `;

/**
 * __useAdminFetchDonationNetworksQuery__
 *
 * To run a query within a React component, call `useAdminFetchDonationNetworksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchDonationNetworksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchDonationNetworksQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAdminFetchDonationNetworksQuery(baseOptions: Apollo.QueryHookOptions<AdminFetchDonationNetworksQuery, AdminFetchDonationNetworksQueryVariables> & ({ variables: AdminFetchDonationNetworksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFetchDonationNetworksQuery, AdminFetchDonationNetworksQueryVariables>(AdminFetchDonationNetworksDocument, options);
      }
export function useAdminFetchDonationNetworksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFetchDonationNetworksQuery, AdminFetchDonationNetworksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFetchDonationNetworksQuery, AdminFetchDonationNetworksQueryVariables>(AdminFetchDonationNetworksDocument, options);
        }
export function useAdminFetchDonationNetworksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFetchDonationNetworksQuery, AdminFetchDonationNetworksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFetchDonationNetworksQuery, AdminFetchDonationNetworksQueryVariables>(AdminFetchDonationNetworksDocument, options);
        }
export type AdminFetchDonationNetworksQueryHookResult = ReturnType<typeof useAdminFetchDonationNetworksQuery>;
export type AdminFetchDonationNetworksLazyQueryHookResult = ReturnType<typeof useAdminFetchDonationNetworksLazyQuery>;
export type AdminFetchDonationNetworksSuspenseQueryHookResult = ReturnType<typeof useAdminFetchDonationNetworksSuspenseQuery>;
export type AdminFetchDonationNetworksQueryResult = Apollo.QueryResult<AdminFetchDonationNetworksQuery, AdminFetchDonationNetworksQueryVariables>;
export const AdminCreateDonationNetworkDocument = gql`
    mutation AdminCreateDonationNetwork($input: CreateDonationNetworkInput!) {
  data: adminCreateDonationNetwork(input: $input) {
    alert {
      type
      message
    }
    payload
  }
}
    `;
export type AdminCreateDonationNetworkMutationFn = Apollo.MutationFunction<AdminCreateDonationNetworkMutation, AdminCreateDonationNetworkMutationVariables>;

/**
 * __useAdminCreateDonationNetworkMutation__
 *
 * To run a mutation, you first call `useAdminCreateDonationNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateDonationNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateDonationNetworkMutation, { data, loading, error }] = useAdminCreateDonationNetworkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateDonationNetworkMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateDonationNetworkMutation, AdminCreateDonationNetworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateDonationNetworkMutation, AdminCreateDonationNetworkMutationVariables>(AdminCreateDonationNetworkDocument, options);
      }
export type AdminCreateDonationNetworkMutationHookResult = ReturnType<typeof useAdminCreateDonationNetworkMutation>;
export type AdminCreateDonationNetworkMutationResult = Apollo.MutationResult<AdminCreateDonationNetworkMutation>;
export type AdminCreateDonationNetworkMutationOptions = Apollo.BaseMutationOptions<AdminCreateDonationNetworkMutation, AdminCreateDonationNetworkMutationVariables>;
export const AdminUpdateDonationNetworkDocument = gql`
    mutation AdminUpdateDonationNetwork($input: UpdateDonationNetworkInput!) {
  data: adminUpdateDonationNetwork(input: $input) {
    alert {
      type
      message
    }
    payload
  }
}
    `;
export type AdminUpdateDonationNetworkMutationFn = Apollo.MutationFunction<AdminUpdateDonationNetworkMutation, AdminUpdateDonationNetworkMutationVariables>;

/**
 * __useAdminUpdateDonationNetworkMutation__
 *
 * To run a mutation, you first call `useAdminUpdateDonationNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateDonationNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateDonationNetworkMutation, { data, loading, error }] = useAdminUpdateDonationNetworkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateDonationNetworkMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateDonationNetworkMutation, AdminUpdateDonationNetworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateDonationNetworkMutation, AdminUpdateDonationNetworkMutationVariables>(AdminUpdateDonationNetworkDocument, options);
      }
export type AdminUpdateDonationNetworkMutationHookResult = ReturnType<typeof useAdminUpdateDonationNetworkMutation>;
export type AdminUpdateDonationNetworkMutationResult = Apollo.MutationResult<AdminUpdateDonationNetworkMutation>;
export type AdminUpdateDonationNetworkMutationOptions = Apollo.BaseMutationOptions<AdminUpdateDonationNetworkMutation, AdminUpdateDonationNetworkMutationVariables>;
export const AdminDeleteDonationNetworkDocument = gql`
    mutation AdminDeleteDonationNetwork($id: String!) {
  data: adminDeleteDonationNetwork(id: $id) {
    alert {
      type
      message
    }
  }
}
    `;
export type AdminDeleteDonationNetworkMutationFn = Apollo.MutationFunction<AdminDeleteDonationNetworkMutation, AdminDeleteDonationNetworkMutationVariables>;

/**
 * __useAdminDeleteDonationNetworkMutation__
 *
 * To run a mutation, you first call `useAdminDeleteDonationNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteDonationNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteDonationNetworkMutation, { data, loading, error }] = useAdminDeleteDonationNetworkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteDonationNetworkMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteDonationNetworkMutation, AdminDeleteDonationNetworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteDonationNetworkMutation, AdminDeleteDonationNetworkMutationVariables>(AdminDeleteDonationNetworkDocument, options);
      }
export type AdminDeleteDonationNetworkMutationHookResult = ReturnType<typeof useAdminDeleteDonationNetworkMutation>;
export type AdminDeleteDonationNetworkMutationResult = Apollo.MutationResult<AdminDeleteDonationNetworkMutation>;
export type AdminDeleteDonationNetworkMutationOptions = Apollo.BaseMutationOptions<AdminDeleteDonationNetworkMutation, AdminDeleteDonationNetworkMutationVariables>;
export const GetInventoryValueDocument = gql`
    query GetInventoryValue {
  data: getInventoryValue {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useGetInventoryValueQuery__
 *
 * To run a query within a React component, call `useGetInventoryValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInventoryValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInventoryValueQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInventoryValueQuery(baseOptions?: Apollo.QueryHookOptions<GetInventoryValueQuery, GetInventoryValueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInventoryValueQuery, GetInventoryValueQueryVariables>(GetInventoryValueDocument, options);
      }
export function useGetInventoryValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInventoryValueQuery, GetInventoryValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInventoryValueQuery, GetInventoryValueQueryVariables>(GetInventoryValueDocument, options);
        }
export function useGetInventoryValueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInventoryValueQuery, GetInventoryValueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInventoryValueQuery, GetInventoryValueQueryVariables>(GetInventoryValueDocument, options);
        }
export type GetInventoryValueQueryHookResult = ReturnType<typeof useGetInventoryValueQuery>;
export type GetInventoryValueLazyQueryHookResult = ReturnType<typeof useGetInventoryValueLazyQuery>;
export type GetInventoryValueSuspenseQueryHookResult = ReturnType<typeof useGetInventoryValueSuspenseQuery>;
export type GetInventoryValueQueryResult = Apollo.QueryResult<GetInventoryValueQuery, GetInventoryValueQueryVariables>;
export const GetInventoryAlertsDocument = gql`
    query GetInventoryAlerts {
  data: getInventoryAlerts {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useGetInventoryAlertsQuery__
 *
 * To run a query within a React component, call `useGetInventoryAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInventoryAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInventoryAlertsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInventoryAlertsQuery(baseOptions?: Apollo.QueryHookOptions<GetInventoryAlertsQuery, GetInventoryAlertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInventoryAlertsQuery, GetInventoryAlertsQueryVariables>(GetInventoryAlertsDocument, options);
      }
export function useGetInventoryAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInventoryAlertsQuery, GetInventoryAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInventoryAlertsQuery, GetInventoryAlertsQueryVariables>(GetInventoryAlertsDocument, options);
        }
export function useGetInventoryAlertsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInventoryAlertsQuery, GetInventoryAlertsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInventoryAlertsQuery, GetInventoryAlertsQueryVariables>(GetInventoryAlertsDocument, options);
        }
export type GetInventoryAlertsQueryHookResult = ReturnType<typeof useGetInventoryAlertsQuery>;
export type GetInventoryAlertsLazyQueryHookResult = ReturnType<typeof useGetInventoryAlertsLazyQuery>;
export type GetInventoryAlertsSuspenseQueryHookResult = ReturnType<typeof useGetInventoryAlertsSuspenseQuery>;
export type GetInventoryAlertsQueryResult = Apollo.QueryResult<GetInventoryAlertsQuery, GetInventoryAlertsQueryVariables>;
export const GetProductMetricsDocument = gql`
    query GetProductMetrics {
  data: getProductMetrics {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useGetProductMetricsQuery__
 *
 * To run a query within a React component, call `useGetProductMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductMetricsQuery, GetProductMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductMetricsQuery, GetProductMetricsQueryVariables>(GetProductMetricsDocument, options);
      }
export function useGetProductMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductMetricsQuery, GetProductMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductMetricsQuery, GetProductMetricsQueryVariables>(GetProductMetricsDocument, options);
        }
export function useGetProductMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductMetricsQuery, GetProductMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductMetricsQuery, GetProductMetricsQueryVariables>(GetProductMetricsDocument, options);
        }
export type GetProductMetricsQueryHookResult = ReturnType<typeof useGetProductMetricsQuery>;
export type GetProductMetricsLazyQueryHookResult = ReturnType<typeof useGetProductMetricsLazyQuery>;
export type GetProductMetricsSuspenseQueryHookResult = ReturnType<typeof useGetProductMetricsSuspenseQuery>;
export type GetProductMetricsQueryResult = Apollo.QueryResult<GetProductMetricsQuery, GetProductMetricsQueryVariables>;
export const GetMetricsTimeSeriesDocument = gql`
    query GetMetricsTimeSeries($queryInput: MetricsQueryInput) {
  data: getMetricsTimeSeries(queryInput: $queryInput) {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useGetMetricsTimeSeriesQuery__
 *
 * To run a query within a React component, call `useGetMetricsTimeSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricsTimeSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricsTimeSeriesQuery({
 *   variables: {
 *      queryInput: // value for 'queryInput'
 *   },
 * });
 */
export function useGetMetricsTimeSeriesQuery(baseOptions?: Apollo.QueryHookOptions<GetMetricsTimeSeriesQuery, GetMetricsTimeSeriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricsTimeSeriesQuery, GetMetricsTimeSeriesQueryVariables>(GetMetricsTimeSeriesDocument, options);
      }
export function useGetMetricsTimeSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricsTimeSeriesQuery, GetMetricsTimeSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricsTimeSeriesQuery, GetMetricsTimeSeriesQueryVariables>(GetMetricsTimeSeriesDocument, options);
        }
export function useGetMetricsTimeSeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMetricsTimeSeriesQuery, GetMetricsTimeSeriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMetricsTimeSeriesQuery, GetMetricsTimeSeriesQueryVariables>(GetMetricsTimeSeriesDocument, options);
        }
export type GetMetricsTimeSeriesQueryHookResult = ReturnType<typeof useGetMetricsTimeSeriesQuery>;
export type GetMetricsTimeSeriesLazyQueryHookResult = ReturnType<typeof useGetMetricsTimeSeriesLazyQuery>;
export type GetMetricsTimeSeriesSuspenseQueryHookResult = ReturnType<typeof useGetMetricsTimeSeriesSuspenseQuery>;
export type GetMetricsTimeSeriesQueryResult = Apollo.QueryResult<GetMetricsTimeSeriesQuery, GetMetricsTimeSeriesQueryVariables>;
export const GetProductPerformanceDocument = gql`
    query GetProductPerformance($queryInput: MetricsQueryInput) {
  data: getProductPerformance(queryInput: $queryInput) {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useGetProductPerformanceQuery__
 *
 * To run a query within a React component, call `useGetProductPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductPerformanceQuery({
 *   variables: {
 *      queryInput: // value for 'queryInput'
 *   },
 * });
 */
export function useGetProductPerformanceQuery(baseOptions?: Apollo.QueryHookOptions<GetProductPerformanceQuery, GetProductPerformanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductPerformanceQuery, GetProductPerformanceQueryVariables>(GetProductPerformanceDocument, options);
      }
export function useGetProductPerformanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductPerformanceQuery, GetProductPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductPerformanceQuery, GetProductPerformanceQueryVariables>(GetProductPerformanceDocument, options);
        }
export function useGetProductPerformanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductPerformanceQuery, GetProductPerformanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductPerformanceQuery, GetProductPerformanceQueryVariables>(GetProductPerformanceDocument, options);
        }
export type GetProductPerformanceQueryHookResult = ReturnType<typeof useGetProductPerformanceQuery>;
export type GetProductPerformanceLazyQueryHookResult = ReturnType<typeof useGetProductPerformanceLazyQuery>;
export type GetProductPerformanceSuspenseQueryHookResult = ReturnType<typeof useGetProductPerformanceSuspenseQuery>;
export type GetProductPerformanceQueryResult = Apollo.QueryResult<GetProductPerformanceQuery, GetProductPerformanceQueryVariables>;
export const GetRevenueForecastDocument = gql`
    query GetRevenueForecast {
  data: getRevenueForecast {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useGetRevenueForecastQuery__
 *
 * To run a query within a React component, call `useGetRevenueForecastQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRevenueForecastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRevenueForecastQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRevenueForecastQuery(baseOptions?: Apollo.QueryHookOptions<GetRevenueForecastQuery, GetRevenueForecastQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRevenueForecastQuery, GetRevenueForecastQueryVariables>(GetRevenueForecastDocument, options);
      }
export function useGetRevenueForecastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRevenueForecastQuery, GetRevenueForecastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRevenueForecastQuery, GetRevenueForecastQueryVariables>(GetRevenueForecastDocument, options);
        }
export function useGetRevenueForecastSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRevenueForecastQuery, GetRevenueForecastQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRevenueForecastQuery, GetRevenueForecastQueryVariables>(GetRevenueForecastDocument, options);
        }
export type GetRevenueForecastQueryHookResult = ReturnType<typeof useGetRevenueForecastQuery>;
export type GetRevenueForecastLazyQueryHookResult = ReturnType<typeof useGetRevenueForecastLazyQuery>;
export type GetRevenueForecastSuspenseQueryHookResult = ReturnType<typeof useGetRevenueForecastSuspenseQuery>;
export type GetRevenueForecastQueryResult = Apollo.QueryResult<GetRevenueForecastQuery, GetRevenueForecastQueryVariables>;
export const LoginAdminDocument = gql`
    mutation loginAdmin($email: String!, $password: String!) {
  data: loginAdmin(email: $email, password: $password) {
    alert {
      message
      type
    }
    payload
  }
}
    `;
export type LoginAdminMutationFn = Apollo.MutationFunction<LoginAdminMutation, LoginAdminMutationVariables>;

/**
 * __useLoginAdminMutation__
 *
 * To run a mutation, you first call `useLoginAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginAdminMutation, { data, loading, error }] = useLoginAdminMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginAdminMutation(baseOptions?: Apollo.MutationHookOptions<LoginAdminMutation, LoginAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginAdminMutation, LoginAdminMutationVariables>(LoginAdminDocument, options);
      }
export type LoginAdminMutationHookResult = ReturnType<typeof useLoginAdminMutation>;
export type LoginAdminMutationResult = Apollo.MutationResult<LoginAdminMutation>;
export type LoginAdminMutationOptions = Apollo.BaseMutationOptions<LoginAdminMutation, LoginAdminMutationVariables>;
export const AdminFetchOrdersDocument = gql`
    query AdminFetchOrders($params: QueryParamsInput!) {
  data: adminFetchOrders(params: $params) {
    alert {
      message
      type
    }
    payload
    pagination {
      currentPage
      pageItems
      totalItems
      totalPages
      totalFilteredItems
    }
  }
}
    `;

/**
 * __useAdminFetchOrdersQuery__
 *
 * To run a query within a React component, call `useAdminFetchOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchOrdersQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAdminFetchOrdersQuery(baseOptions: Apollo.QueryHookOptions<AdminFetchOrdersQuery, AdminFetchOrdersQueryVariables> & ({ variables: AdminFetchOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFetchOrdersQuery, AdminFetchOrdersQueryVariables>(AdminFetchOrdersDocument, options);
      }
export function useAdminFetchOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFetchOrdersQuery, AdminFetchOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFetchOrdersQuery, AdminFetchOrdersQueryVariables>(AdminFetchOrdersDocument, options);
        }
export function useAdminFetchOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFetchOrdersQuery, AdminFetchOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFetchOrdersQuery, AdminFetchOrdersQueryVariables>(AdminFetchOrdersDocument, options);
        }
export type AdminFetchOrdersQueryHookResult = ReturnType<typeof useAdminFetchOrdersQuery>;
export type AdminFetchOrdersLazyQueryHookResult = ReturnType<typeof useAdminFetchOrdersLazyQuery>;
export type AdminFetchOrdersSuspenseQueryHookResult = ReturnType<typeof useAdminFetchOrdersSuspenseQuery>;
export type AdminFetchOrdersQueryResult = Apollo.QueryResult<AdminFetchOrdersQuery, AdminFetchOrdersQueryVariables>;
export const AdminFetchOrderDocument = gql`
    query AdminFetchOrder($orderId: String!) {
  data: adminFetchOrder(orderId: $orderId) {
    alert {
      message
      type
    }
    payload
  }
}
    `;

/**
 * __useAdminFetchOrderQuery__
 *
 * To run a query within a React component, call `useAdminFetchOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useAdminFetchOrderQuery(baseOptions: Apollo.QueryHookOptions<AdminFetchOrderQuery, AdminFetchOrderQueryVariables> & ({ variables: AdminFetchOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFetchOrderQuery, AdminFetchOrderQueryVariables>(AdminFetchOrderDocument, options);
      }
export function useAdminFetchOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFetchOrderQuery, AdminFetchOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFetchOrderQuery, AdminFetchOrderQueryVariables>(AdminFetchOrderDocument, options);
        }
export function useAdminFetchOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFetchOrderQuery, AdminFetchOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFetchOrderQuery, AdminFetchOrderQueryVariables>(AdminFetchOrderDocument, options);
        }
export type AdminFetchOrderQueryHookResult = ReturnType<typeof useAdminFetchOrderQuery>;
export type AdminFetchOrderLazyQueryHookResult = ReturnType<typeof useAdminFetchOrderLazyQuery>;
export type AdminFetchOrderSuspenseQueryHookResult = ReturnType<typeof useAdminFetchOrderSuspenseQuery>;
export type AdminFetchOrderQueryResult = Apollo.QueryResult<AdminFetchOrderQuery, AdminFetchOrderQueryVariables>;
export const AdminUpdateOrderStatusDocument = gql`
    mutation AdminUpdateOrderStatus($orderId: String!, $status: String!) {
  data: adminUpdateOrderStatus(orderId: $orderId, status: $status) {
    alert {
      message
      type
    }
    payload
  }
}
    `;
export type AdminUpdateOrderStatusMutationFn = Apollo.MutationFunction<AdminUpdateOrderStatusMutation, AdminUpdateOrderStatusMutationVariables>;

/**
 * __useAdminUpdateOrderStatusMutation__
 *
 * To run a mutation, you first call `useAdminUpdateOrderStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateOrderStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateOrderStatusMutation, { data, loading, error }] = useAdminUpdateOrderStatusMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useAdminUpdateOrderStatusMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateOrderStatusMutation, AdminUpdateOrderStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateOrderStatusMutation, AdminUpdateOrderStatusMutationVariables>(AdminUpdateOrderStatusDocument, options);
      }
export type AdminUpdateOrderStatusMutationHookResult = ReturnType<typeof useAdminUpdateOrderStatusMutation>;
export type AdminUpdateOrderStatusMutationResult = Apollo.MutationResult<AdminUpdateOrderStatusMutation>;
export type AdminUpdateOrderStatusMutationOptions = Apollo.BaseMutationOptions<AdminUpdateOrderStatusMutation, AdminUpdateOrderStatusMutationVariables>;
export const AdminSendEmailToCustomerAboutOrderDocument = gql`
    mutation AdminSendEmailToCustomerAboutOrder($orderId: String!, $emailInput: SendEmailInput!) {
  data: adminSendEmailToCustomerAboutOrder(
    orderId: $orderId
    emailInput: $emailInput
  ) {
    alert {
      message
      type
    }
    payload
  }
}
    `;
export type AdminSendEmailToCustomerAboutOrderMutationFn = Apollo.MutationFunction<AdminSendEmailToCustomerAboutOrderMutation, AdminSendEmailToCustomerAboutOrderMutationVariables>;

/**
 * __useAdminSendEmailToCustomerAboutOrderMutation__
 *
 * To run a mutation, you first call `useAdminSendEmailToCustomerAboutOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSendEmailToCustomerAboutOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSendEmailToCustomerAboutOrderMutation, { data, loading, error }] = useAdminSendEmailToCustomerAboutOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      emailInput: // value for 'emailInput'
 *   },
 * });
 */
export function useAdminSendEmailToCustomerAboutOrderMutation(baseOptions?: Apollo.MutationHookOptions<AdminSendEmailToCustomerAboutOrderMutation, AdminSendEmailToCustomerAboutOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSendEmailToCustomerAboutOrderMutation, AdminSendEmailToCustomerAboutOrderMutationVariables>(AdminSendEmailToCustomerAboutOrderDocument, options);
      }
export type AdminSendEmailToCustomerAboutOrderMutationHookResult = ReturnType<typeof useAdminSendEmailToCustomerAboutOrderMutation>;
export type AdminSendEmailToCustomerAboutOrderMutationResult = Apollo.MutationResult<AdminSendEmailToCustomerAboutOrderMutation>;
export type AdminSendEmailToCustomerAboutOrderMutationOptions = Apollo.BaseMutationOptions<AdminSendEmailToCustomerAboutOrderMutation, AdminSendEmailToCustomerAboutOrderMutationVariables>;
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($orderId: String!, $updateOrderInput: UpdateOrderInput!) {
  data: updateOrder(orderId: $orderId, updateOrderInput: $updateOrderInput) {
    alert {
      type
      message
    }
    payload
  }
}
    `;
export type UpdateOrderMutationFn = Apollo.MutationFunction<UpdateOrderMutation, UpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      updateOrderInput: // value for 'updateOrderInput'
 *   },
 * });
 */
export function useUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderMutation, UpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(UpdateOrderDocument, options);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = Apollo.MutationResult<UpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const AdminFetchPaymentPlansDocument = gql`
    query AdminFetchPaymentPlans($params: QueryParamsInput!) {
  data: adminFetchPaymentPlans(params: $params) {
    alert {
      type
      message
    }
    pagination {
      currentPage
      pageItems
      totalItems
      totalPages
      totalFilteredItems
    }
    payload
  }
}
    `;

/**
 * __useAdminFetchPaymentPlansQuery__
 *
 * To run a query within a React component, call `useAdminFetchPaymentPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchPaymentPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchPaymentPlansQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAdminFetchPaymentPlansQuery(baseOptions: Apollo.QueryHookOptions<AdminFetchPaymentPlansQuery, AdminFetchPaymentPlansQueryVariables> & ({ variables: AdminFetchPaymentPlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFetchPaymentPlansQuery, AdminFetchPaymentPlansQueryVariables>(AdminFetchPaymentPlansDocument, options);
      }
export function useAdminFetchPaymentPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFetchPaymentPlansQuery, AdminFetchPaymentPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFetchPaymentPlansQuery, AdminFetchPaymentPlansQueryVariables>(AdminFetchPaymentPlansDocument, options);
        }
export function useAdminFetchPaymentPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFetchPaymentPlansQuery, AdminFetchPaymentPlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFetchPaymentPlansQuery, AdminFetchPaymentPlansQueryVariables>(AdminFetchPaymentPlansDocument, options);
        }
export type AdminFetchPaymentPlansQueryHookResult = ReturnType<typeof useAdminFetchPaymentPlansQuery>;
export type AdminFetchPaymentPlansLazyQueryHookResult = ReturnType<typeof useAdminFetchPaymentPlansLazyQuery>;
export type AdminFetchPaymentPlansSuspenseQueryHookResult = ReturnType<typeof useAdminFetchPaymentPlansSuspenseQuery>;
export type AdminFetchPaymentPlansQueryResult = Apollo.QueryResult<AdminFetchPaymentPlansQuery, AdminFetchPaymentPlansQueryVariables>;
export const FetchAdminPaymentPlansOnlyDocument = gql`
    query FetchAdminPaymentPlansOnly($params: QueryParamsInput!) {
  data: fetchAdminPaymentPlansOnly(params: $params) {
    alert {
      type
      message
    }
    pagination {
      currentPage
      pageItems
      totalItems
      totalPages
      totalFilteredItems
    }
    payload
  }
}
    `;

/**
 * __useFetchAdminPaymentPlansOnlyQuery__
 *
 * To run a query within a React component, call `useFetchAdminPaymentPlansOnlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAdminPaymentPlansOnlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAdminPaymentPlansOnlyQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useFetchAdminPaymentPlansOnlyQuery(baseOptions: Apollo.QueryHookOptions<FetchAdminPaymentPlansOnlyQuery, FetchAdminPaymentPlansOnlyQueryVariables> & ({ variables: FetchAdminPaymentPlansOnlyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAdminPaymentPlansOnlyQuery, FetchAdminPaymentPlansOnlyQueryVariables>(FetchAdminPaymentPlansOnlyDocument, options);
      }
export function useFetchAdminPaymentPlansOnlyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAdminPaymentPlansOnlyQuery, FetchAdminPaymentPlansOnlyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAdminPaymentPlansOnlyQuery, FetchAdminPaymentPlansOnlyQueryVariables>(FetchAdminPaymentPlansOnlyDocument, options);
        }
export function useFetchAdminPaymentPlansOnlySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchAdminPaymentPlansOnlyQuery, FetchAdminPaymentPlansOnlyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAdminPaymentPlansOnlyQuery, FetchAdminPaymentPlansOnlyQueryVariables>(FetchAdminPaymentPlansOnlyDocument, options);
        }
export type FetchAdminPaymentPlansOnlyQueryHookResult = ReturnType<typeof useFetchAdminPaymentPlansOnlyQuery>;
export type FetchAdminPaymentPlansOnlyLazyQueryHookResult = ReturnType<typeof useFetchAdminPaymentPlansOnlyLazyQuery>;
export type FetchAdminPaymentPlansOnlySuspenseQueryHookResult = ReturnType<typeof useFetchAdminPaymentPlansOnlySuspenseQuery>;
export type FetchAdminPaymentPlansOnlyQueryResult = Apollo.QueryResult<FetchAdminPaymentPlansOnlyQuery, FetchAdminPaymentPlansOnlyQueryVariables>;
export const FetchPaymentBonusFieldsDocument = gql`
    query FetchPaymentBonusFields {
  data: fetchPaymentBonusFields {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useFetchPaymentBonusFieldsQuery__
 *
 * To run a query within a React component, call `useFetchPaymentBonusFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPaymentBonusFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPaymentBonusFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchPaymentBonusFieldsQuery(baseOptions?: Apollo.QueryHookOptions<FetchPaymentBonusFieldsQuery, FetchPaymentBonusFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPaymentBonusFieldsQuery, FetchPaymentBonusFieldsQueryVariables>(FetchPaymentBonusFieldsDocument, options);
      }
export function useFetchPaymentBonusFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPaymentBonusFieldsQuery, FetchPaymentBonusFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPaymentBonusFieldsQuery, FetchPaymentBonusFieldsQueryVariables>(FetchPaymentBonusFieldsDocument, options);
        }
export function useFetchPaymentBonusFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchPaymentBonusFieldsQuery, FetchPaymentBonusFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchPaymentBonusFieldsQuery, FetchPaymentBonusFieldsQueryVariables>(FetchPaymentBonusFieldsDocument, options);
        }
export type FetchPaymentBonusFieldsQueryHookResult = ReturnType<typeof useFetchPaymentBonusFieldsQuery>;
export type FetchPaymentBonusFieldsLazyQueryHookResult = ReturnType<typeof useFetchPaymentBonusFieldsLazyQuery>;
export type FetchPaymentBonusFieldsSuspenseQueryHookResult = ReturnType<typeof useFetchPaymentBonusFieldsSuspenseQuery>;
export type FetchPaymentBonusFieldsQueryResult = Apollo.QueryResult<FetchPaymentBonusFieldsQuery, FetchPaymentBonusFieldsQueryVariables>;
export const FetchPaymentBonusTemplatesDocument = gql`
    query FetchPaymentBonusTemplates($params: QueryParamsInput!) {
  data: fetchPaymentBonusTemplates(params: $params) {
    payload
    alert {
      message
      type
    }
    pagination {
      currentPage
      pageItems
      totalItems
      totalPages
      totalFilteredItems
    }
  }
}
    `;

/**
 * __useFetchPaymentBonusTemplatesQuery__
 *
 * To run a query within a React component, call `useFetchPaymentBonusTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPaymentBonusTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPaymentBonusTemplatesQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useFetchPaymentBonusTemplatesQuery(baseOptions: Apollo.QueryHookOptions<FetchPaymentBonusTemplatesQuery, FetchPaymentBonusTemplatesQueryVariables> & ({ variables: FetchPaymentBonusTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPaymentBonusTemplatesQuery, FetchPaymentBonusTemplatesQueryVariables>(FetchPaymentBonusTemplatesDocument, options);
      }
export function useFetchPaymentBonusTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPaymentBonusTemplatesQuery, FetchPaymentBonusTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPaymentBonusTemplatesQuery, FetchPaymentBonusTemplatesQueryVariables>(FetchPaymentBonusTemplatesDocument, options);
        }
export function useFetchPaymentBonusTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchPaymentBonusTemplatesQuery, FetchPaymentBonusTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchPaymentBonusTemplatesQuery, FetchPaymentBonusTemplatesQueryVariables>(FetchPaymentBonusTemplatesDocument, options);
        }
export type FetchPaymentBonusTemplatesQueryHookResult = ReturnType<typeof useFetchPaymentBonusTemplatesQuery>;
export type FetchPaymentBonusTemplatesLazyQueryHookResult = ReturnType<typeof useFetchPaymentBonusTemplatesLazyQuery>;
export type FetchPaymentBonusTemplatesSuspenseQueryHookResult = ReturnType<typeof useFetchPaymentBonusTemplatesSuspenseQuery>;
export type FetchPaymentBonusTemplatesQueryResult = Apollo.QueryResult<FetchPaymentBonusTemplatesQuery, FetchPaymentBonusTemplatesQueryVariables>;
export const CreatePaymentBonusTemplateDocument = gql`
    mutation CreatePaymentBonusTemplate($createPaymentBonusTemplateInput: CreatePaymentBonusTemplateInput!) {
  data: createPaymentBonusTemplate(
    createPaymentBonusTemplateInput: $createPaymentBonusTemplateInput
  ) {
    alert {
      type
      message
    }
    payload
  }
}
    `;
export type CreatePaymentBonusTemplateMutationFn = Apollo.MutationFunction<CreatePaymentBonusTemplateMutation, CreatePaymentBonusTemplateMutationVariables>;

/**
 * __useCreatePaymentBonusTemplateMutation__
 *
 * To run a mutation, you first call `useCreatePaymentBonusTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentBonusTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentBonusTemplateMutation, { data, loading, error }] = useCreatePaymentBonusTemplateMutation({
 *   variables: {
 *      createPaymentBonusTemplateInput: // value for 'createPaymentBonusTemplateInput'
 *   },
 * });
 */
export function useCreatePaymentBonusTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentBonusTemplateMutation, CreatePaymentBonusTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentBonusTemplateMutation, CreatePaymentBonusTemplateMutationVariables>(CreatePaymentBonusTemplateDocument, options);
      }
export type CreatePaymentBonusTemplateMutationHookResult = ReturnType<typeof useCreatePaymentBonusTemplateMutation>;
export type CreatePaymentBonusTemplateMutationResult = Apollo.MutationResult<CreatePaymentBonusTemplateMutation>;
export type CreatePaymentBonusTemplateMutationOptions = Apollo.BaseMutationOptions<CreatePaymentBonusTemplateMutation, CreatePaymentBonusTemplateMutationVariables>;
export const CreatePaymentBonusFieldDocument = gql`
    mutation CreatePaymentBonusField($createPaymentBonusFieldInput: CreatePaymentBonusFieldInput!) {
  data: createPaymentBonusField(
    createPaymentBonusFieldInput: $createPaymentBonusFieldInput
  ) {
    alert {
      type
      message
    }
    payload
  }
}
    `;
export type CreatePaymentBonusFieldMutationFn = Apollo.MutationFunction<CreatePaymentBonusFieldMutation, CreatePaymentBonusFieldMutationVariables>;

/**
 * __useCreatePaymentBonusFieldMutation__
 *
 * To run a mutation, you first call `useCreatePaymentBonusFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentBonusFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentBonusFieldMutation, { data, loading, error }] = useCreatePaymentBonusFieldMutation({
 *   variables: {
 *      createPaymentBonusFieldInput: // value for 'createPaymentBonusFieldInput'
 *   },
 * });
 */
export function useCreatePaymentBonusFieldMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentBonusFieldMutation, CreatePaymentBonusFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentBonusFieldMutation, CreatePaymentBonusFieldMutationVariables>(CreatePaymentBonusFieldDocument, options);
      }
export type CreatePaymentBonusFieldMutationHookResult = ReturnType<typeof useCreatePaymentBonusFieldMutation>;
export type CreatePaymentBonusFieldMutationResult = Apollo.MutationResult<CreatePaymentBonusFieldMutation>;
export type CreatePaymentBonusFieldMutationOptions = Apollo.BaseMutationOptions<CreatePaymentBonusFieldMutation, CreatePaymentBonusFieldMutationVariables>;
export const DeletePaymentBonusFieldDocument = gql`
    mutation DeletePaymentBonusField($id: ID!) {
  removePaymentBonusField(id: $id) {
    alert {
      type
      message
    }
    payload
  }
}
    `;
export type DeletePaymentBonusFieldMutationFn = Apollo.MutationFunction<DeletePaymentBonusFieldMutation, DeletePaymentBonusFieldMutationVariables>;

/**
 * __useDeletePaymentBonusFieldMutation__
 *
 * To run a mutation, you first call `useDeletePaymentBonusFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentBonusFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentBonusFieldMutation, { data, loading, error }] = useDeletePaymentBonusFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePaymentBonusFieldMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentBonusFieldMutation, DeletePaymentBonusFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentBonusFieldMutation, DeletePaymentBonusFieldMutationVariables>(DeletePaymentBonusFieldDocument, options);
      }
export type DeletePaymentBonusFieldMutationHookResult = ReturnType<typeof useDeletePaymentBonusFieldMutation>;
export type DeletePaymentBonusFieldMutationResult = Apollo.MutationResult<DeletePaymentBonusFieldMutation>;
export type DeletePaymentBonusFieldMutationOptions = Apollo.BaseMutationOptions<DeletePaymentBonusFieldMutation, DeletePaymentBonusFieldMutationVariables>;
export const DeletePaymentBonusTemplateDocument = gql`
    mutation DeletePaymentBonusTemplate($paymentBonusTemplateId: String!) {
  data: deletePaymentBonusTemplate(
    paymentBonusTemplateId: $paymentBonusTemplateId
  ) {
    alert {
      type
      message
    }
    payload
  }
}
    `;
export type DeletePaymentBonusTemplateMutationFn = Apollo.MutationFunction<DeletePaymentBonusTemplateMutation, DeletePaymentBonusTemplateMutationVariables>;

/**
 * __useDeletePaymentBonusTemplateMutation__
 *
 * To run a mutation, you first call `useDeletePaymentBonusTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentBonusTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentBonusTemplateMutation, { data, loading, error }] = useDeletePaymentBonusTemplateMutation({
 *   variables: {
 *      paymentBonusTemplateId: // value for 'paymentBonusTemplateId'
 *   },
 * });
 */
export function useDeletePaymentBonusTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentBonusTemplateMutation, DeletePaymentBonusTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentBonusTemplateMutation, DeletePaymentBonusTemplateMutationVariables>(DeletePaymentBonusTemplateDocument, options);
      }
export type DeletePaymentBonusTemplateMutationHookResult = ReturnType<typeof useDeletePaymentBonusTemplateMutation>;
export type DeletePaymentBonusTemplateMutationResult = Apollo.MutationResult<DeletePaymentBonusTemplateMutation>;
export type DeletePaymentBonusTemplateMutationOptions = Apollo.BaseMutationOptions<DeletePaymentBonusTemplateMutation, DeletePaymentBonusTemplateMutationVariables>;
export const EditPaymentBonusTemplateDocument = gql`
    mutation EditPaymentBonusTemplate($paymentBonusTemplateId: String!, $editPaymentBonusTemplateInput: UpdatePaymentBonusTemplateInput!) {
  data: editPaymentBonusTemplate(
    paymentBonusTemplateId: $paymentBonusTemplateId
    editPaymentBonusTemplateInput: $editPaymentBonusTemplateInput
  ) {
    alert {
      type
      message
    }
    payload
  }
}
    `;
export type EditPaymentBonusTemplateMutationFn = Apollo.MutationFunction<EditPaymentBonusTemplateMutation, EditPaymentBonusTemplateMutationVariables>;

/**
 * __useEditPaymentBonusTemplateMutation__
 *
 * To run a mutation, you first call `useEditPaymentBonusTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPaymentBonusTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPaymentBonusTemplateMutation, { data, loading, error }] = useEditPaymentBonusTemplateMutation({
 *   variables: {
 *      paymentBonusTemplateId: // value for 'paymentBonusTemplateId'
 *      editPaymentBonusTemplateInput: // value for 'editPaymentBonusTemplateInput'
 *   },
 * });
 */
export function useEditPaymentBonusTemplateMutation(baseOptions?: Apollo.MutationHookOptions<EditPaymentBonusTemplateMutation, EditPaymentBonusTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPaymentBonusTemplateMutation, EditPaymentBonusTemplateMutationVariables>(EditPaymentBonusTemplateDocument, options);
      }
export type EditPaymentBonusTemplateMutationHookResult = ReturnType<typeof useEditPaymentBonusTemplateMutation>;
export type EditPaymentBonusTemplateMutationResult = Apollo.MutationResult<EditPaymentBonusTemplateMutation>;
export type EditPaymentBonusTemplateMutationOptions = Apollo.BaseMutationOptions<EditPaymentBonusTemplateMutation, EditPaymentBonusTemplateMutationVariables>;
export const CreatePaymentPlanDocument = gql`
    mutation CreatePaymentPlan($createPaymentPlanInput: CreatePaymentPlanInput!) {
  data: adminCreatePaymentPlan(createPaymentPlanInput: $createPaymentPlanInput) {
    alert {
      type
      message
    }
    payload
  }
}
    `;
export type CreatePaymentPlanMutationFn = Apollo.MutationFunction<CreatePaymentPlanMutation, CreatePaymentPlanMutationVariables>;

/**
 * __useCreatePaymentPlanMutation__
 *
 * To run a mutation, you first call `useCreatePaymentPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentPlanMutation, { data, loading, error }] = useCreatePaymentPlanMutation({
 *   variables: {
 *      createPaymentPlanInput: // value for 'createPaymentPlanInput'
 *   },
 * });
 */
export function useCreatePaymentPlanMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentPlanMutation, CreatePaymentPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentPlanMutation, CreatePaymentPlanMutationVariables>(CreatePaymentPlanDocument, options);
      }
export type CreatePaymentPlanMutationHookResult = ReturnType<typeof useCreatePaymentPlanMutation>;
export type CreatePaymentPlanMutationResult = Apollo.MutationResult<CreatePaymentPlanMutation>;
export type CreatePaymentPlanMutationOptions = Apollo.BaseMutationOptions<CreatePaymentPlanMutation, CreatePaymentPlanMutationVariables>;
export const UpdatePaymentPlanDocument = gql`
    mutation UpdatePaymentPlan($updatePaymentPlanInput: UpdatePaymentPlanInput!, $paymentPlanId: String!) {
  data: adminUpdatePaymentPlan(
    updatePaymentPlanInput: $updatePaymentPlanInput
    paymentPlanId: $paymentPlanId
  ) {
    alert {
      type
      message
    }
    payload
  }
}
    `;
export type UpdatePaymentPlanMutationFn = Apollo.MutationFunction<UpdatePaymentPlanMutation, UpdatePaymentPlanMutationVariables>;

/**
 * __useUpdatePaymentPlanMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentPlanMutation, { data, loading, error }] = useUpdatePaymentPlanMutation({
 *   variables: {
 *      updatePaymentPlanInput: // value for 'updatePaymentPlanInput'
 *      paymentPlanId: // value for 'paymentPlanId'
 *   },
 * });
 */
export function useUpdatePaymentPlanMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentPlanMutation, UpdatePaymentPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentPlanMutation, UpdatePaymentPlanMutationVariables>(UpdatePaymentPlanDocument, options);
      }
export type UpdatePaymentPlanMutationHookResult = ReturnType<typeof useUpdatePaymentPlanMutation>;
export type UpdatePaymentPlanMutationResult = Apollo.MutationResult<UpdatePaymentPlanMutation>;
export type UpdatePaymentPlanMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentPlanMutation, UpdatePaymentPlanMutationVariables>;
export const DeletePaymentPlanDocument = gql`
    mutation DeletePaymentPlan($paymentPlanId: String!) {
  data: adminDeletePaymentPlan(paymentPlanId: $paymentPlanId) {
    alert {
      type
      message
    }
    payload
  }
}
    `;
export type DeletePaymentPlanMutationFn = Apollo.MutationFunction<DeletePaymentPlanMutation, DeletePaymentPlanMutationVariables>;

/**
 * __useDeletePaymentPlanMutation__
 *
 * To run a mutation, you first call `useDeletePaymentPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentPlanMutation, { data, loading, error }] = useDeletePaymentPlanMutation({
 *   variables: {
 *      paymentPlanId: // value for 'paymentPlanId'
 *   },
 * });
 */
export function useDeletePaymentPlanMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentPlanMutation, DeletePaymentPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentPlanMutation, DeletePaymentPlanMutationVariables>(DeletePaymentPlanDocument, options);
      }
export type DeletePaymentPlanMutationHookResult = ReturnType<typeof useDeletePaymentPlanMutation>;
export type DeletePaymentPlanMutationResult = Apollo.MutationResult<DeletePaymentPlanMutation>;
export type DeletePaymentPlanMutationOptions = Apollo.BaseMutationOptions<DeletePaymentPlanMutation, DeletePaymentPlanMutationVariables>;
export const CreateProductDocument = gql`
    mutation CreateProduct($createProductInput: CreateProductInput!) {
  data: createProduct(createProductInput: $createProductInput) {
    alert {
      type
      message
    }
    payload
  }
}
    `;
export type CreateProductMutationFn = Apollo.MutationFunction<CreateProductMutation, CreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      createProductInput: // value for 'createProductInput'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductMutation, CreateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument, options);
      }
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<CreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<CreateProductMutation, CreateProductMutationVariables>;
export const FetchProductsDocument = gql`
    query FetchProducts($queryInput: ProductQueryInput) {
  data: findAllProducts(queryInput: $queryInput) {
    alert {
      type
      message
    }
    pagination {
      currentPage
      pageItems
      totalItems
      totalPages
      totalFilteredItems
    }
    payload
  }
}
    `;

/**
 * __useFetchProductsQuery__
 *
 * To run a query within a React component, call `useFetchProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductsQuery({
 *   variables: {
 *      queryInput: // value for 'queryInput'
 *   },
 * });
 */
export function useFetchProductsQuery(baseOptions?: Apollo.QueryHookOptions<FetchProductsQuery, FetchProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchProductsQuery, FetchProductsQueryVariables>(FetchProductsDocument, options);
      }
export function useFetchProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchProductsQuery, FetchProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchProductsQuery, FetchProductsQueryVariables>(FetchProductsDocument, options);
        }
export function useFetchProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchProductsQuery, FetchProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchProductsQuery, FetchProductsQueryVariables>(FetchProductsDocument, options);
        }
export type FetchProductsQueryHookResult = ReturnType<typeof useFetchProductsQuery>;
export type FetchProductsLazyQueryHookResult = ReturnType<typeof useFetchProductsLazyQuery>;
export type FetchProductsSuspenseQueryHookResult = ReturnType<typeof useFetchProductsSuspenseQuery>;
export type FetchProductsQueryResult = Apollo.QueryResult<FetchProductsQuery, FetchProductsQueryVariables>;
export const FetchProductByIdDocument = gql`
    query FetchProductById($id: String!) {
  data: findProductById(id: $id) {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useFetchProductByIdQuery__
 *
 * To run a query within a React component, call `useFetchProductByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchProductByIdQuery(baseOptions: Apollo.QueryHookOptions<FetchProductByIdQuery, FetchProductByIdQueryVariables> & ({ variables: FetchProductByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchProductByIdQuery, FetchProductByIdQueryVariables>(FetchProductByIdDocument, options);
      }
export function useFetchProductByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchProductByIdQuery, FetchProductByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchProductByIdQuery, FetchProductByIdQueryVariables>(FetchProductByIdDocument, options);
        }
export function useFetchProductByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchProductByIdQuery, FetchProductByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchProductByIdQuery, FetchProductByIdQueryVariables>(FetchProductByIdDocument, options);
        }
export type FetchProductByIdQueryHookResult = ReturnType<typeof useFetchProductByIdQuery>;
export type FetchProductByIdLazyQueryHookResult = ReturnType<typeof useFetchProductByIdLazyQuery>;
export type FetchProductByIdSuspenseQueryHookResult = ReturnType<typeof useFetchProductByIdSuspenseQuery>;
export type FetchProductByIdQueryResult = Apollo.QueryResult<FetchProductByIdQuery, FetchProductByIdQueryVariables>;
export const UpdateProductDocument = gql`
    mutation UpdateProduct($id: String!, $updateProductInput: UpdateProductInput!) {
  data: updateProduct(id: $id, updateProductInput: $updateProductInput) {
    alert {
      type
      message
    }
    payload
  }
}
    `;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateProductInput: // value for 'updateProductInput'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const DeleteProductDocument = gql`
    mutation DeleteProduct($id: String!) {
  data: deleteProduct(id: $id) {
    alert {
      type
      message
    }
    payload
  }
}
    `;
export type DeleteProductMutationFn = Apollo.MutationFunction<DeleteProductMutation, DeleteProductMutationVariables>;

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductMutation, DeleteProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductMutation, DeleteProductMutationVariables>(DeleteProductDocument, options);
      }
export type DeleteProductMutationHookResult = ReturnType<typeof useDeleteProductMutation>;
export type DeleteProductMutationResult = Apollo.MutationResult<DeleteProductMutation>;
export type DeleteProductMutationOptions = Apollo.BaseMutationOptions<DeleteProductMutation, DeleteProductMutationVariables>;
export const FetchAccountPlansDocument = gql`
    query FetchAccountPlans {
  data: fetchAccountPlans {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useFetchAccountPlansQuery__
 *
 * To run a query within a React component, call `useFetchAccountPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAccountPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAccountPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAccountPlansQuery(baseOptions?: Apollo.QueryHookOptions<FetchAccountPlansQuery, FetchAccountPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAccountPlansQuery, FetchAccountPlansQueryVariables>(FetchAccountPlansDocument, options);
      }
export function useFetchAccountPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAccountPlansQuery, FetchAccountPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAccountPlansQuery, FetchAccountPlansQueryVariables>(FetchAccountPlansDocument, options);
        }
export function useFetchAccountPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchAccountPlansQuery, FetchAccountPlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAccountPlansQuery, FetchAccountPlansQueryVariables>(FetchAccountPlansDocument, options);
        }
export type FetchAccountPlansQueryHookResult = ReturnType<typeof useFetchAccountPlansQuery>;
export type FetchAccountPlansLazyQueryHookResult = ReturnType<typeof useFetchAccountPlansLazyQuery>;
export type FetchAccountPlansSuspenseQueryHookResult = ReturnType<typeof useFetchAccountPlansSuspenseQuery>;
export type FetchAccountPlansQueryResult = Apollo.QueryResult<FetchAccountPlansQuery, FetchAccountPlansQueryVariables>;
export const FetchAllCurrenciesDocument = gql`
    query FetchAllCurrencies {
  data: fetchAllCurrencies {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useFetchAllCurrenciesQuery__
 *
 * To run a query within a React component, call `useFetchAllCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAllCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<FetchAllCurrenciesQuery, FetchAllCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllCurrenciesQuery, FetchAllCurrenciesQueryVariables>(FetchAllCurrenciesDocument, options);
      }
export function useFetchAllCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllCurrenciesQuery, FetchAllCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllCurrenciesQuery, FetchAllCurrenciesQueryVariables>(FetchAllCurrenciesDocument, options);
        }
export function useFetchAllCurrenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchAllCurrenciesQuery, FetchAllCurrenciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAllCurrenciesQuery, FetchAllCurrenciesQueryVariables>(FetchAllCurrenciesDocument, options);
        }
export type FetchAllCurrenciesQueryHookResult = ReturnType<typeof useFetchAllCurrenciesQuery>;
export type FetchAllCurrenciesLazyQueryHookResult = ReturnType<typeof useFetchAllCurrenciesLazyQuery>;
export type FetchAllCurrenciesSuspenseQueryHookResult = ReturnType<typeof useFetchAllCurrenciesSuspenseQuery>;
export type FetchAllCurrenciesQueryResult = Apollo.QueryResult<FetchAllCurrenciesQuery, FetchAllCurrenciesQueryVariables>;
export const AdminFetchTransactionsDocument = gql`
    query AdminFetchTransactions($params: QueryParamsInput!) {
  data: adminFetchTransactions(params: $params) {
    alert {
      type
      message
    }
    payload
    pagination {
      currentPage
      pageItems
      totalItems
      totalPages
      totalFilteredItems
    }
  }
}
    `;

/**
 * __useAdminFetchTransactionsQuery__
 *
 * To run a query within a React component, call `useAdminFetchTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchTransactionsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAdminFetchTransactionsQuery(baseOptions: Apollo.QueryHookOptions<AdminFetchTransactionsQuery, AdminFetchTransactionsQueryVariables> & ({ variables: AdminFetchTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFetchTransactionsQuery, AdminFetchTransactionsQueryVariables>(AdminFetchTransactionsDocument, options);
      }
export function useAdminFetchTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFetchTransactionsQuery, AdminFetchTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFetchTransactionsQuery, AdminFetchTransactionsQueryVariables>(AdminFetchTransactionsDocument, options);
        }
export function useAdminFetchTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFetchTransactionsQuery, AdminFetchTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFetchTransactionsQuery, AdminFetchTransactionsQueryVariables>(AdminFetchTransactionsDocument, options);
        }
export type AdminFetchTransactionsQueryHookResult = ReturnType<typeof useAdminFetchTransactionsQuery>;
export type AdminFetchTransactionsLazyQueryHookResult = ReturnType<typeof useAdminFetchTransactionsLazyQuery>;
export type AdminFetchTransactionsSuspenseQueryHookResult = ReturnType<typeof useAdminFetchTransactionsSuspenseQuery>;
export type AdminFetchTransactionsQueryResult = Apollo.QueryResult<AdminFetchTransactionsQuery, AdminFetchTransactionsQueryVariables>;
export const AdminFetchTransactionDocument = gql`
    query AdminFetchTransaction($transactionId: String!) {
  data: adminFetchTransaction(transactionId: $transactionId) {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useAdminFetchTransactionQuery__
 *
 * To run a query within a React component, call `useAdminFetchTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchTransactionQuery({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useAdminFetchTransactionQuery(baseOptions: Apollo.QueryHookOptions<AdminFetchTransactionQuery, AdminFetchTransactionQueryVariables> & ({ variables: AdminFetchTransactionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFetchTransactionQuery, AdminFetchTransactionQueryVariables>(AdminFetchTransactionDocument, options);
      }
export function useAdminFetchTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFetchTransactionQuery, AdminFetchTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFetchTransactionQuery, AdminFetchTransactionQueryVariables>(AdminFetchTransactionDocument, options);
        }
export function useAdminFetchTransactionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFetchTransactionQuery, AdminFetchTransactionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFetchTransactionQuery, AdminFetchTransactionQueryVariables>(AdminFetchTransactionDocument, options);
        }
export type AdminFetchTransactionQueryHookResult = ReturnType<typeof useAdminFetchTransactionQuery>;
export type AdminFetchTransactionLazyQueryHookResult = ReturnType<typeof useAdminFetchTransactionLazyQuery>;
export type AdminFetchTransactionSuspenseQueryHookResult = ReturnType<typeof useAdminFetchTransactionSuspenseQuery>;
export type AdminFetchTransactionQueryResult = Apollo.QueryResult<AdminFetchTransactionQuery, AdminFetchTransactionQueryVariables>;
export const AdminFetchCustomerCountDocument = gql`
    query AdminFetchCustomerCount {
  data: adminFetchCustomerCount {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useAdminFetchCustomerCountQuery__
 *
 * To run a query within a React component, call `useAdminFetchCustomerCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchCustomerCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchCustomerCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminFetchCustomerCountQuery(baseOptions?: Apollo.QueryHookOptions<AdminFetchCustomerCountQuery, AdminFetchCustomerCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFetchCustomerCountQuery, AdminFetchCustomerCountQueryVariables>(AdminFetchCustomerCountDocument, options);
      }
export function useAdminFetchCustomerCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFetchCustomerCountQuery, AdminFetchCustomerCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFetchCustomerCountQuery, AdminFetchCustomerCountQueryVariables>(AdminFetchCustomerCountDocument, options);
        }
export function useAdminFetchCustomerCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFetchCustomerCountQuery, AdminFetchCustomerCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFetchCustomerCountQuery, AdminFetchCustomerCountQueryVariables>(AdminFetchCustomerCountDocument, options);
        }
export type AdminFetchCustomerCountQueryHookResult = ReturnType<typeof useAdminFetchCustomerCountQuery>;
export type AdminFetchCustomerCountLazyQueryHookResult = ReturnType<typeof useAdminFetchCustomerCountLazyQuery>;
export type AdminFetchCustomerCountSuspenseQueryHookResult = ReturnType<typeof useAdminFetchCustomerCountSuspenseQuery>;
export type AdminFetchCustomerCountQueryResult = Apollo.QueryResult<AdminFetchCustomerCountQuery, AdminFetchCustomerCountQueryVariables>;
export const AdminFetchDistributorCountDocument = gql`
    query AdminFetchDistributorCount {
  data: adminFetchDistributorCount {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useAdminFetchDistributorCountQuery__
 *
 * To run a query within a React component, call `useAdminFetchDistributorCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchDistributorCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchDistributorCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminFetchDistributorCountQuery(baseOptions?: Apollo.QueryHookOptions<AdminFetchDistributorCountQuery, AdminFetchDistributorCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFetchDistributorCountQuery, AdminFetchDistributorCountQueryVariables>(AdminFetchDistributorCountDocument, options);
      }
export function useAdminFetchDistributorCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFetchDistributorCountQuery, AdminFetchDistributorCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFetchDistributorCountQuery, AdminFetchDistributorCountQueryVariables>(AdminFetchDistributorCountDocument, options);
        }
export function useAdminFetchDistributorCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFetchDistributorCountQuery, AdminFetchDistributorCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFetchDistributorCountQuery, AdminFetchDistributorCountQueryVariables>(AdminFetchDistributorCountDocument, options);
        }
export type AdminFetchDistributorCountQueryHookResult = ReturnType<typeof useAdminFetchDistributorCountQuery>;
export type AdminFetchDistributorCountLazyQueryHookResult = ReturnType<typeof useAdminFetchDistributorCountLazyQuery>;
export type AdminFetchDistributorCountSuspenseQueryHookResult = ReturnType<typeof useAdminFetchDistributorCountSuspenseQuery>;
export type AdminFetchDistributorCountQueryResult = Apollo.QueryResult<AdminFetchDistributorCountQuery, AdminFetchDistributorCountQueryVariables>;
export const AdminFetchDeviceCountDocument = gql`
    query AdminFetchDeviceCount {
  data: adminFetchDeviceCount {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useAdminFetchDeviceCountQuery__
 *
 * To run a query within a React component, call `useAdminFetchDeviceCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchDeviceCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchDeviceCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminFetchDeviceCountQuery(baseOptions?: Apollo.QueryHookOptions<AdminFetchDeviceCountQuery, AdminFetchDeviceCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFetchDeviceCountQuery, AdminFetchDeviceCountQueryVariables>(AdminFetchDeviceCountDocument, options);
      }
export function useAdminFetchDeviceCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFetchDeviceCountQuery, AdminFetchDeviceCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFetchDeviceCountQuery, AdminFetchDeviceCountQueryVariables>(AdminFetchDeviceCountDocument, options);
        }
export function useAdminFetchDeviceCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFetchDeviceCountQuery, AdminFetchDeviceCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFetchDeviceCountQuery, AdminFetchDeviceCountQueryVariables>(AdminFetchDeviceCountDocument, options);
        }
export type AdminFetchDeviceCountQueryHookResult = ReturnType<typeof useAdminFetchDeviceCountQuery>;
export type AdminFetchDeviceCountLazyQueryHookResult = ReturnType<typeof useAdminFetchDeviceCountLazyQuery>;
export type AdminFetchDeviceCountSuspenseQueryHookResult = ReturnType<typeof useAdminFetchDeviceCountSuspenseQuery>;
export type AdminFetchDeviceCountQueryResult = Apollo.QueryResult<AdminFetchDeviceCountQuery, AdminFetchDeviceCountQueryVariables>;
export const AdminFetchTransactionCountDocument = gql`
    query AdminFetchTransactionCount {
  data: adminFetchTransactionCount {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useAdminFetchTransactionCountQuery__
 *
 * To run a query within a React component, call `useAdminFetchTransactionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchTransactionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchTransactionCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminFetchTransactionCountQuery(baseOptions?: Apollo.QueryHookOptions<AdminFetchTransactionCountQuery, AdminFetchTransactionCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFetchTransactionCountQuery, AdminFetchTransactionCountQueryVariables>(AdminFetchTransactionCountDocument, options);
      }
export function useAdminFetchTransactionCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFetchTransactionCountQuery, AdminFetchTransactionCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFetchTransactionCountQuery, AdminFetchTransactionCountQueryVariables>(AdminFetchTransactionCountDocument, options);
        }
export function useAdminFetchTransactionCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFetchTransactionCountQuery, AdminFetchTransactionCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFetchTransactionCountQuery, AdminFetchTransactionCountQueryVariables>(AdminFetchTransactionCountDocument, options);
        }
export type AdminFetchTransactionCountQueryHookResult = ReturnType<typeof useAdminFetchTransactionCountQuery>;
export type AdminFetchTransactionCountLazyQueryHookResult = ReturnType<typeof useAdminFetchTransactionCountLazyQuery>;
export type AdminFetchTransactionCountSuspenseQueryHookResult = ReturnType<typeof useAdminFetchTransactionCountSuspenseQuery>;
export type AdminFetchTransactionCountQueryResult = Apollo.QueryResult<AdminFetchTransactionCountQuery, AdminFetchTransactionCountQueryVariables>;
export const AdminDeleteTransactionDocument = gql`
    mutation AdminDeleteTransaction($transactionId: String!) {
  data: adminDeleteTransaction(transactionId: $transactionId) {
    alert {
      type
      message
    }
    payload
  }
}
    `;
export type AdminDeleteTransactionMutationFn = Apollo.MutationFunction<AdminDeleteTransactionMutation, AdminDeleteTransactionMutationVariables>;

/**
 * __useAdminDeleteTransactionMutation__
 *
 * To run a mutation, you first call `useAdminDeleteTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteTransactionMutation, { data, loading, error }] = useAdminDeleteTransactionMutation({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useAdminDeleteTransactionMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteTransactionMutation, AdminDeleteTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteTransactionMutation, AdminDeleteTransactionMutationVariables>(AdminDeleteTransactionDocument, options);
      }
export type AdminDeleteTransactionMutationHookResult = ReturnType<typeof useAdminDeleteTransactionMutation>;
export type AdminDeleteTransactionMutationResult = Apollo.MutationResult<AdminDeleteTransactionMutation>;
export type AdminDeleteTransactionMutationOptions = Apollo.BaseMutationOptions<AdminDeleteTransactionMutation, AdminDeleteTransactionMutationVariables>;
export const AdminFetchUsdcTransactionsSumDocument = gql`
    query AdminFetchUsdcTransactionsSum {
  data: adminFetchUsdcTransactionsSum {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useAdminFetchUsdcTransactionsSumQuery__
 *
 * To run a query within a React component, call `useAdminFetchUsdcTransactionsSumQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchUsdcTransactionsSumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchUsdcTransactionsSumQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminFetchUsdcTransactionsSumQuery(baseOptions?: Apollo.QueryHookOptions<AdminFetchUsdcTransactionsSumQuery, AdminFetchUsdcTransactionsSumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFetchUsdcTransactionsSumQuery, AdminFetchUsdcTransactionsSumQueryVariables>(AdminFetchUsdcTransactionsSumDocument, options);
      }
export function useAdminFetchUsdcTransactionsSumLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFetchUsdcTransactionsSumQuery, AdminFetchUsdcTransactionsSumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFetchUsdcTransactionsSumQuery, AdminFetchUsdcTransactionsSumQueryVariables>(AdminFetchUsdcTransactionsSumDocument, options);
        }
export function useAdminFetchUsdcTransactionsSumSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFetchUsdcTransactionsSumQuery, AdminFetchUsdcTransactionsSumQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFetchUsdcTransactionsSumQuery, AdminFetchUsdcTransactionsSumQueryVariables>(AdminFetchUsdcTransactionsSumDocument, options);
        }
export type AdminFetchUsdcTransactionsSumQueryHookResult = ReturnType<typeof useAdminFetchUsdcTransactionsSumQuery>;
export type AdminFetchUsdcTransactionsSumLazyQueryHookResult = ReturnType<typeof useAdminFetchUsdcTransactionsSumLazyQuery>;
export type AdminFetchUsdcTransactionsSumSuspenseQueryHookResult = ReturnType<typeof useAdminFetchUsdcTransactionsSumSuspenseQuery>;
export type AdminFetchUsdcTransactionsSumQueryResult = Apollo.QueryResult<AdminFetchUsdcTransactionsSumQuery, AdminFetchUsdcTransactionsSumQueryVariables>;
export const AdminFetchUssdTransactionsSumDocument = gql`
    query AdminFetchUssdTransactionsSum {
  data: adminFetchUssdTransactionsSum {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useAdminFetchUssdTransactionsSumQuery__
 *
 * To run a query within a React component, call `useAdminFetchUssdTransactionsSumQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchUssdTransactionsSumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchUssdTransactionsSumQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminFetchUssdTransactionsSumQuery(baseOptions?: Apollo.QueryHookOptions<AdminFetchUssdTransactionsSumQuery, AdminFetchUssdTransactionsSumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFetchUssdTransactionsSumQuery, AdminFetchUssdTransactionsSumQueryVariables>(AdminFetchUssdTransactionsSumDocument, options);
      }
export function useAdminFetchUssdTransactionsSumLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFetchUssdTransactionsSumQuery, AdminFetchUssdTransactionsSumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFetchUssdTransactionsSumQuery, AdminFetchUssdTransactionsSumQueryVariables>(AdminFetchUssdTransactionsSumDocument, options);
        }
export function useAdminFetchUssdTransactionsSumSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFetchUssdTransactionsSumQuery, AdminFetchUssdTransactionsSumQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFetchUssdTransactionsSumQuery, AdminFetchUssdTransactionsSumQueryVariables>(AdminFetchUssdTransactionsSumDocument, options);
        }
export type AdminFetchUssdTransactionsSumQueryHookResult = ReturnType<typeof useAdminFetchUssdTransactionsSumQuery>;
export type AdminFetchUssdTransactionsSumLazyQueryHookResult = ReturnType<typeof useAdminFetchUssdTransactionsSumLazyQuery>;
export type AdminFetchUssdTransactionsSumSuspenseQueryHookResult = ReturnType<typeof useAdminFetchUssdTransactionsSumSuspenseQuery>;
export type AdminFetchUssdTransactionsSumQueryResult = Apollo.QueryResult<AdminFetchUssdTransactionsSumQuery, AdminFetchUssdTransactionsSumQueryVariables>;
export const AdminFetchPurchasedDevicesCountDocument = gql`
    query AdminFetchPurchasedDevicesCount {
  data: adminFetchPurchasedDevicesCount {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useAdminFetchPurchasedDevicesCountQuery__
 *
 * To run a query within a React component, call `useAdminFetchPurchasedDevicesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchPurchasedDevicesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchPurchasedDevicesCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminFetchPurchasedDevicesCountQuery(baseOptions?: Apollo.QueryHookOptions<AdminFetchPurchasedDevicesCountQuery, AdminFetchPurchasedDevicesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFetchPurchasedDevicesCountQuery, AdminFetchPurchasedDevicesCountQueryVariables>(AdminFetchPurchasedDevicesCountDocument, options);
      }
export function useAdminFetchPurchasedDevicesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFetchPurchasedDevicesCountQuery, AdminFetchPurchasedDevicesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFetchPurchasedDevicesCountQuery, AdminFetchPurchasedDevicesCountQueryVariables>(AdminFetchPurchasedDevicesCountDocument, options);
        }
export function useAdminFetchPurchasedDevicesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFetchPurchasedDevicesCountQuery, AdminFetchPurchasedDevicesCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFetchPurchasedDevicesCountQuery, AdminFetchPurchasedDevicesCountQueryVariables>(AdminFetchPurchasedDevicesCountDocument, options);
        }
export type AdminFetchPurchasedDevicesCountQueryHookResult = ReturnType<typeof useAdminFetchPurchasedDevicesCountQuery>;
export type AdminFetchPurchasedDevicesCountLazyQueryHookResult = ReturnType<typeof useAdminFetchPurchasedDevicesCountLazyQuery>;
export type AdminFetchPurchasedDevicesCountSuspenseQueryHookResult = ReturnType<typeof useAdminFetchPurchasedDevicesCountSuspenseQuery>;
export type AdminFetchPurchasedDevicesCountQueryResult = Apollo.QueryResult<AdminFetchPurchasedDevicesCountQuery, AdminFetchPurchasedDevicesCountQueryVariables>;
export const AdminFetchTotalRevenueDocument = gql`
    query AdminFetchTotalRevenue {
  data: adminFetchTotalRevenue {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useAdminFetchTotalRevenueQuery__
 *
 * To run a query within a React component, call `useAdminFetchTotalRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchTotalRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchTotalRevenueQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminFetchTotalRevenueQuery(baseOptions?: Apollo.QueryHookOptions<AdminFetchTotalRevenueQuery, AdminFetchTotalRevenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFetchTotalRevenueQuery, AdminFetchTotalRevenueQueryVariables>(AdminFetchTotalRevenueDocument, options);
      }
export function useAdminFetchTotalRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFetchTotalRevenueQuery, AdminFetchTotalRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFetchTotalRevenueQuery, AdminFetchTotalRevenueQueryVariables>(AdminFetchTotalRevenueDocument, options);
        }
export function useAdminFetchTotalRevenueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFetchTotalRevenueQuery, AdminFetchTotalRevenueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFetchTotalRevenueQuery, AdminFetchTotalRevenueQueryVariables>(AdminFetchTotalRevenueDocument, options);
        }
export type AdminFetchTotalRevenueQueryHookResult = ReturnType<typeof useAdminFetchTotalRevenueQuery>;
export type AdminFetchTotalRevenueLazyQueryHookResult = ReturnType<typeof useAdminFetchTotalRevenueLazyQuery>;
export type AdminFetchTotalRevenueSuspenseQueryHookResult = ReturnType<typeof useAdminFetchTotalRevenueSuspenseQuery>;
export type AdminFetchTotalRevenueQueryResult = Apollo.QueryResult<AdminFetchTotalRevenueQuery, AdminFetchTotalRevenueQueryVariables>;
export const GetCurrentAdminProfileDocument = gql`
    query GetCurrentAdminProfile {
  data: getCurrentAdminProfile {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useGetCurrentAdminProfileQuery__
 *
 * To run a query within a React component, call `useGetCurrentAdminProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentAdminProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentAdminProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentAdminProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentAdminProfileQuery, GetCurrentAdminProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentAdminProfileQuery, GetCurrentAdminProfileQueryVariables>(GetCurrentAdminProfileDocument, options);
      }
export function useGetCurrentAdminProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentAdminProfileQuery, GetCurrentAdminProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentAdminProfileQuery, GetCurrentAdminProfileQueryVariables>(GetCurrentAdminProfileDocument, options);
        }
export function useGetCurrentAdminProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentAdminProfileQuery, GetCurrentAdminProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentAdminProfileQuery, GetCurrentAdminProfileQueryVariables>(GetCurrentAdminProfileDocument, options);
        }
export type GetCurrentAdminProfileQueryHookResult = ReturnType<typeof useGetCurrentAdminProfileQuery>;
export type GetCurrentAdminProfileLazyQueryHookResult = ReturnType<typeof useGetCurrentAdminProfileLazyQuery>;
export type GetCurrentAdminProfileSuspenseQueryHookResult = ReturnType<typeof useGetCurrentAdminProfileSuspenseQuery>;
export type GetCurrentAdminProfileQueryResult = Apollo.QueryResult<GetCurrentAdminProfileQuery, GetCurrentAdminProfileQueryVariables>;
export const UpdateAdminProfileDocument = gql`
    mutation UpdateAdminProfile($fullName: String!, $email: String!) {
  data: updateAdminProfile(fullName: $fullName, email: $email) {
    alert {
      type
      message
    }
    payload
  }
}
    `;
export type UpdateAdminProfileMutationFn = Apollo.MutationFunction<UpdateAdminProfileMutation, UpdateAdminProfileMutationVariables>;

/**
 * __useUpdateAdminProfileMutation__
 *
 * To run a mutation, you first call `useUpdateAdminProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminProfileMutation, { data, loading, error }] = useUpdateAdminProfileMutation({
 *   variables: {
 *      fullName: // value for 'fullName'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUpdateAdminProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminProfileMutation, UpdateAdminProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminProfileMutation, UpdateAdminProfileMutationVariables>(UpdateAdminProfileDocument, options);
      }
export type UpdateAdminProfileMutationHookResult = ReturnType<typeof useUpdateAdminProfileMutation>;
export type UpdateAdminProfileMutationResult = Apollo.MutationResult<UpdateAdminProfileMutation>;
export type UpdateAdminProfileMutationOptions = Apollo.BaseMutationOptions<UpdateAdminProfileMutation, UpdateAdminProfileMutationVariables>;
export const SendPasswordChangeOtpDocument = gql`
    mutation SendPasswordChangeOtp {
  data: sendPasswordChangeOtp {
    alert {
      type
      message
    }
    payload
  }
}
    `;
export type SendPasswordChangeOtpMutationFn = Apollo.MutationFunction<SendPasswordChangeOtpMutation, SendPasswordChangeOtpMutationVariables>;

/**
 * __useSendPasswordChangeOtpMutation__
 *
 * To run a mutation, you first call `useSendPasswordChangeOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordChangeOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordChangeOtpMutation, { data, loading, error }] = useSendPasswordChangeOtpMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendPasswordChangeOtpMutation(baseOptions?: Apollo.MutationHookOptions<SendPasswordChangeOtpMutation, SendPasswordChangeOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPasswordChangeOtpMutation, SendPasswordChangeOtpMutationVariables>(SendPasswordChangeOtpDocument, options);
      }
export type SendPasswordChangeOtpMutationHookResult = ReturnType<typeof useSendPasswordChangeOtpMutation>;
export type SendPasswordChangeOtpMutationResult = Apollo.MutationResult<SendPasswordChangeOtpMutation>;
export type SendPasswordChangeOtpMutationOptions = Apollo.BaseMutationOptions<SendPasswordChangeOtpMutation, SendPasswordChangeOtpMutationVariables>;
export const ChangeAdminPasswordDocument = gql`
    mutation ChangeAdminPassword($currentPassword: String!, $newPassword: String!, $otpCode: String) {
  data: changeAdminPassword(
    currentPassword: $currentPassword
    newPassword: $newPassword
    otpCode: $otpCode
  ) {
    alert {
      type
      message
    }
    payload
  }
}
    `;
export type ChangeAdminPasswordMutationFn = Apollo.MutationFunction<ChangeAdminPasswordMutation, ChangeAdminPasswordMutationVariables>;

/**
 * __useChangeAdminPasswordMutation__
 *
 * To run a mutation, you first call `useChangeAdminPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeAdminPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeAdminPasswordMutation, { data, loading, error }] = useChangeAdminPasswordMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      newPassword: // value for 'newPassword'
 *      otpCode: // value for 'otpCode'
 *   },
 * });
 */
export function useChangeAdminPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangeAdminPasswordMutation, ChangeAdminPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeAdminPasswordMutation, ChangeAdminPasswordMutationVariables>(ChangeAdminPasswordDocument, options);
      }
export type ChangeAdminPasswordMutationHookResult = ReturnType<typeof useChangeAdminPasswordMutation>;
export type ChangeAdminPasswordMutationResult = Apollo.MutationResult<ChangeAdminPasswordMutation>;
export type ChangeAdminPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeAdminPasswordMutation, ChangeAdminPasswordMutationVariables>;
export const AdminFetchActivationDebugTracesDocument = gql`
    query AdminFetchActivationDebugTraces($params: QueryParamsInput!) {
  data: adminFetchActivationDebugTraces(params: $params) {
    alert {
      type
      message
    }
    payload
    pagination {
      currentPage
      pageItems
      totalItems
      totalPages
      totalFilteredItems
    }
  }
}
    `;

/**
 * __useAdminFetchActivationDebugTracesQuery__
 *
 * To run a query within a React component, call `useAdminFetchActivationDebugTracesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchActivationDebugTracesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchActivationDebugTracesQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAdminFetchActivationDebugTracesQuery(baseOptions: Apollo.QueryHookOptions<AdminFetchActivationDebugTracesQuery, AdminFetchActivationDebugTracesQueryVariables> & ({ variables: AdminFetchActivationDebugTracesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFetchActivationDebugTracesQuery, AdminFetchActivationDebugTracesQueryVariables>(AdminFetchActivationDebugTracesDocument, options);
      }
export function useAdminFetchActivationDebugTracesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFetchActivationDebugTracesQuery, AdminFetchActivationDebugTracesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFetchActivationDebugTracesQuery, AdminFetchActivationDebugTracesQueryVariables>(AdminFetchActivationDebugTracesDocument, options);
        }
export function useAdminFetchActivationDebugTracesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFetchActivationDebugTracesQuery, AdminFetchActivationDebugTracesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFetchActivationDebugTracesQuery, AdminFetchActivationDebugTracesQueryVariables>(AdminFetchActivationDebugTracesDocument, options);
        }
export type AdminFetchActivationDebugTracesQueryHookResult = ReturnType<typeof useAdminFetchActivationDebugTracesQuery>;
export type AdminFetchActivationDebugTracesLazyQueryHookResult = ReturnType<typeof useAdminFetchActivationDebugTracesLazyQuery>;
export type AdminFetchActivationDebugTracesSuspenseQueryHookResult = ReturnType<typeof useAdminFetchActivationDebugTracesSuspenseQuery>;
export type AdminFetchActivationDebugTracesQueryResult = Apollo.QueryResult<AdminFetchActivationDebugTracesQuery, AdminFetchActivationDebugTracesQueryVariables>;
export const AdminFetchActivationDebugTraceDocument = gql`
    query AdminFetchActivationDebugTrace($id: String!) {
  data: adminFetchActivationDebugTrace(id: $id) {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useAdminFetchActivationDebugTraceQuery__
 *
 * To run a query within a React component, call `useAdminFetchActivationDebugTraceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchActivationDebugTraceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchActivationDebugTraceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminFetchActivationDebugTraceQuery(baseOptions: Apollo.QueryHookOptions<AdminFetchActivationDebugTraceQuery, AdminFetchActivationDebugTraceQueryVariables> & ({ variables: AdminFetchActivationDebugTraceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFetchActivationDebugTraceQuery, AdminFetchActivationDebugTraceQueryVariables>(AdminFetchActivationDebugTraceDocument, options);
      }
export function useAdminFetchActivationDebugTraceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFetchActivationDebugTraceQuery, AdminFetchActivationDebugTraceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFetchActivationDebugTraceQuery, AdminFetchActivationDebugTraceQueryVariables>(AdminFetchActivationDebugTraceDocument, options);
        }
export function useAdminFetchActivationDebugTraceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFetchActivationDebugTraceQuery, AdminFetchActivationDebugTraceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFetchActivationDebugTraceQuery, AdminFetchActivationDebugTraceQueryVariables>(AdminFetchActivationDebugTraceDocument, options);
        }
export type AdminFetchActivationDebugTraceQueryHookResult = ReturnType<typeof useAdminFetchActivationDebugTraceQuery>;
export type AdminFetchActivationDebugTraceLazyQueryHookResult = ReturnType<typeof useAdminFetchActivationDebugTraceLazyQuery>;
export type AdminFetchActivationDebugTraceSuspenseQueryHookResult = ReturnType<typeof useAdminFetchActivationDebugTraceSuspenseQuery>;
export type AdminFetchActivationDebugTraceQueryResult = Apollo.QueryResult<AdminFetchActivationDebugTraceQuery, AdminFetchActivationDebugTraceQueryVariables>;
export const AdminFetchProcessedCircleWebhooksDocument = gql`
    query AdminFetchProcessedCircleWebhooks($params: QueryParamsInput!) {
  data: adminFetchProcessedCircleWebhooks(params: $params) {
    alert {
      type
      message
    }
    payload
    pagination {
      currentPage
      pageItems
      totalItems
      totalPages
      totalFilteredItems
    }
  }
}
    `;

/**
 * __useAdminFetchProcessedCircleWebhooksQuery__
 *
 * To run a query within a React component, call `useAdminFetchProcessedCircleWebhooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchProcessedCircleWebhooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchProcessedCircleWebhooksQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAdminFetchProcessedCircleWebhooksQuery(baseOptions: Apollo.QueryHookOptions<AdminFetchProcessedCircleWebhooksQuery, AdminFetchProcessedCircleWebhooksQueryVariables> & ({ variables: AdminFetchProcessedCircleWebhooksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFetchProcessedCircleWebhooksQuery, AdminFetchProcessedCircleWebhooksQueryVariables>(AdminFetchProcessedCircleWebhooksDocument, options);
      }
export function useAdminFetchProcessedCircleWebhooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFetchProcessedCircleWebhooksQuery, AdminFetchProcessedCircleWebhooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFetchProcessedCircleWebhooksQuery, AdminFetchProcessedCircleWebhooksQueryVariables>(AdminFetchProcessedCircleWebhooksDocument, options);
        }
export function useAdminFetchProcessedCircleWebhooksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFetchProcessedCircleWebhooksQuery, AdminFetchProcessedCircleWebhooksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFetchProcessedCircleWebhooksQuery, AdminFetchProcessedCircleWebhooksQueryVariables>(AdminFetchProcessedCircleWebhooksDocument, options);
        }
export type AdminFetchProcessedCircleWebhooksQueryHookResult = ReturnType<typeof useAdminFetchProcessedCircleWebhooksQuery>;
export type AdminFetchProcessedCircleWebhooksLazyQueryHookResult = ReturnType<typeof useAdminFetchProcessedCircleWebhooksLazyQuery>;
export type AdminFetchProcessedCircleWebhooksSuspenseQueryHookResult = ReturnType<typeof useAdminFetchProcessedCircleWebhooksSuspenseQuery>;
export type AdminFetchProcessedCircleWebhooksQueryResult = Apollo.QueryResult<AdminFetchProcessedCircleWebhooksQuery, AdminFetchProcessedCircleWebhooksQueryVariables>;
export const AdminFetchProcessedCircleWebhookDocument = gql`
    query AdminFetchProcessedCircleWebhook($id: String!) {
  data: adminFetchProcessedCircleWebhook(id: $id) {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useAdminFetchProcessedCircleWebhookQuery__
 *
 * To run a query within a React component, call `useAdminFetchProcessedCircleWebhookQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchProcessedCircleWebhookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchProcessedCircleWebhookQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminFetchProcessedCircleWebhookQuery(baseOptions: Apollo.QueryHookOptions<AdminFetchProcessedCircleWebhookQuery, AdminFetchProcessedCircleWebhookQueryVariables> & ({ variables: AdminFetchProcessedCircleWebhookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFetchProcessedCircleWebhookQuery, AdminFetchProcessedCircleWebhookQueryVariables>(AdminFetchProcessedCircleWebhookDocument, options);
      }
export function useAdminFetchProcessedCircleWebhookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFetchProcessedCircleWebhookQuery, AdminFetchProcessedCircleWebhookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFetchProcessedCircleWebhookQuery, AdminFetchProcessedCircleWebhookQueryVariables>(AdminFetchProcessedCircleWebhookDocument, options);
        }
export function useAdminFetchProcessedCircleWebhookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFetchProcessedCircleWebhookQuery, AdminFetchProcessedCircleWebhookQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFetchProcessedCircleWebhookQuery, AdminFetchProcessedCircleWebhookQueryVariables>(AdminFetchProcessedCircleWebhookDocument, options);
        }
export type AdminFetchProcessedCircleWebhookQueryHookResult = ReturnType<typeof useAdminFetchProcessedCircleWebhookQuery>;
export type AdminFetchProcessedCircleWebhookLazyQueryHookResult = ReturnType<typeof useAdminFetchProcessedCircleWebhookLazyQuery>;
export type AdminFetchProcessedCircleWebhookSuspenseQueryHookResult = ReturnType<typeof useAdminFetchProcessedCircleWebhookSuspenseQuery>;
export type AdminFetchProcessedCircleWebhookQueryResult = Apollo.QueryResult<AdminFetchProcessedCircleWebhookQuery, AdminFetchProcessedCircleWebhookQueryVariables>;
export const AdminFetchProcessedCircleWebhookByTxHashDocument = gql`
    query AdminFetchProcessedCircleWebhookByTxHash($blockchain: String!, $txHash: String!) {
  data: adminFetchProcessedCircleWebhookByTxHash(
    blockchain: $blockchain
    txHash: $txHash
  ) {
    alert {
      type
      message
    }
    payload
  }
}
    `;

/**
 * __useAdminFetchProcessedCircleWebhookByTxHashQuery__
 *
 * To run a query within a React component, call `useAdminFetchProcessedCircleWebhookByTxHashQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchProcessedCircleWebhookByTxHashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchProcessedCircleWebhookByTxHashQuery({
 *   variables: {
 *      blockchain: // value for 'blockchain'
 *      txHash: // value for 'txHash'
 *   },
 * });
 */
export function useAdminFetchProcessedCircleWebhookByTxHashQuery(baseOptions: Apollo.QueryHookOptions<AdminFetchProcessedCircleWebhookByTxHashQuery, AdminFetchProcessedCircleWebhookByTxHashQueryVariables> & ({ variables: AdminFetchProcessedCircleWebhookByTxHashQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminFetchProcessedCircleWebhookByTxHashQuery, AdminFetchProcessedCircleWebhookByTxHashQueryVariables>(AdminFetchProcessedCircleWebhookByTxHashDocument, options);
      }
export function useAdminFetchProcessedCircleWebhookByTxHashLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminFetchProcessedCircleWebhookByTxHashQuery, AdminFetchProcessedCircleWebhookByTxHashQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminFetchProcessedCircleWebhookByTxHashQuery, AdminFetchProcessedCircleWebhookByTxHashQueryVariables>(AdminFetchProcessedCircleWebhookByTxHashDocument, options);
        }
export function useAdminFetchProcessedCircleWebhookByTxHashSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminFetchProcessedCircleWebhookByTxHashQuery, AdminFetchProcessedCircleWebhookByTxHashQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminFetchProcessedCircleWebhookByTxHashQuery, AdminFetchProcessedCircleWebhookByTxHashQueryVariables>(AdminFetchProcessedCircleWebhookByTxHashDocument, options);
        }
export type AdminFetchProcessedCircleWebhookByTxHashQueryHookResult = ReturnType<typeof useAdminFetchProcessedCircleWebhookByTxHashQuery>;
export type AdminFetchProcessedCircleWebhookByTxHashLazyQueryHookResult = ReturnType<typeof useAdminFetchProcessedCircleWebhookByTxHashLazyQuery>;
export type AdminFetchProcessedCircleWebhookByTxHashSuspenseQueryHookResult = ReturnType<typeof useAdminFetchProcessedCircleWebhookByTxHashSuspenseQuery>;
export type AdminFetchProcessedCircleWebhookByTxHashQueryResult = Apollo.QueryResult<AdminFetchProcessedCircleWebhookByTxHashQuery, AdminFetchProcessedCircleWebhookByTxHashQueryVariables>;